/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react'
import Menu from '../assets/icons/MenuIcon.svg'
import Close from '../assets/icons/CloseIcon.svg'
import Facebook from '../assets/icons/facebook.svg'
import Twitter from '../assets/icons/twitter.svg'
import Instagram from '../assets/icons/instagram.svg'
import Linkedin from '../assets/icons/linkedin.svg'
import Calender from '../assets/icons/calender.svg'
import Check from '../assets/icons/Check.svg'
import BankNote from '../assets/icons/banknote.svg'
import Clock from '../assets/icons/clock.svg'
import CreditReport from '../assets/icons/creditreport.svg'
import User from '../assets/icons/user.svg'
import Tip from '../assets/icons/tip.svg'
import Bank from '../assets/icons/bank.svg'
import Intro from '../assets/icons/intro.svg'
import phoneIcon from '../assets/icons/phoneIcon.svg'

export {
Menu,
Close,
Facebook,
Twitter,
Instagram,
Linkedin,
Calender,
Check,
BankNote,
Clock,
CreditReport,
User,
Tip,
Bank,
Intro,
phoneIcon
}

export function MenuIcon({ fill = '#000' }) {
return (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_112_2299)">
      <path
        d="M3.9987 8H19.9779C20.3298 8 20.8252 7.73282 20.9766 7C21.0078 6.59084 21.0078 6.40916 20.9766 6C20.8252 5.26658 20.3299 5 19.9779 5H3.9987C3.39343 5 3 5.28128 3 6C3 5.951 3 7.01564 3 7C3 7.75214 3.4628 8 3.9987 8ZM19.9779 16H3.9987C3.39343 16 3 16.2813 3 17C3 16.951 3 18.0156 3 18C3 18.7521 3.4628 19 3.9987 19H19.9779C20.3298 19 20.8252 18.7328 20.9766 18C21.0078 17.5908 21.0078 17.4092 20.9766 17C20.8252 16.2666 20.3299 16 19.9779 16ZM19.9779 10.5H3.9987C3.39343 10.5 3 10.7813 3 11.5C3 11.451 3 12.5156 3 12.5C3 13.2521 3.4628 13.5 3.9987 13.5H19.9779C20.3298 13.5 20.8252 13.2328 20.9766 12.5C21.0078 12.0908 21.0078 11.9092 20.9766 11.5C20.8252 10.7666 20.3299 10.5 19.9779 10.5Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_112_2299">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function CloseIcon({ fill = '#000' }) {
return (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_b_1560_1875)">
      <rect width="24" height="24" rx="12" fill="#6C819C" fillOpacity="0.4" />
      <g clipPath="url(#clip0_1560_1875)">
        <path
          d="M14.1019 12.0002L16.7937 9.30931C17.0281 9.07494 17.0676 8.7238 16.8874 8.49921C16.4754 7.98561 16.0138 7.52392 15.5006 7.11333C15.2774 6.93269 14.9262 6.97264 14.6919 7.20701L12.0005 9.78427L9.30784 7.20565C9.07484 6.97219 8.7228 6.93224 8.49866 7.11287C7.98729 7.52392 7.52474 7.98602 7.1137 8.4983C6.9317 8.72289 6.9721 9.07449 7.20692 9.30795L9.89871 12.0002L7.20602 14.6925C6.97256 14.9259 6.9326 15.2771 7.11324 15.5017C7.52429 16.013 7.98638 16.4756 8.49866 16.8866C8.72327 17.0682 9.07484 17.0278 9.3083 16.7934L12.0001 14.1016L14.691 16.7934C14.9253 17.0278 15.2765 17.0673 15.5011 16.8866C16.0147 16.4751 16.4763 16.0135 16.8874 15.5003C17.0676 15.2771 17.0276 14.9259 16.7937 14.6916L14.1019 12.0002Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_b_1560_1875"
        x="-3"
        y="-3"
        width="30"
        height="30"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.5" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1560_1875"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1560_1875"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_1560_1875">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(6 6)"
        />
      </clipPath>
    </defs>
  </svg>
)
}
export function CloseIconSmall({ fill = '#000' }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_b_1560_1875)">
      <rect width="24" height="24" rx="12" fill="#6C819C" fillOpacity="0.4" />
      <g clipPath="url(#clip0_1560_1875)">
        <path
          d="M14.1019 12.0002L16.7937 9.30931C17.0281 9.07494 17.0676 8.7238 16.8874 8.49921C16.4754 7.98561 16.0138 7.52392 15.5006 7.11333C15.2774 6.93269 14.9262 6.97264 14.6919 7.20701L12.0005 9.78427L9.30784 7.20565C9.07484 6.97219 8.7228 6.93224 8.49866 7.11287C7.98729 7.52392 7.52474 7.98602 7.1137 8.4983C6.9317 8.72289 6.9721 9.07449 7.20692 9.30795L9.89871 12.0002L7.20602 14.6925C6.97256 14.9259 6.9326 15.2771 7.11324 15.5017C7.52429 16.013 7.98638 16.4756 8.49866 16.8866C8.72327 17.0682 9.07484 17.0278 9.3083 16.7934L12.0001 14.1016L14.691 16.7934C14.9253 17.0278 15.2765 17.0673 15.5011 16.8866C16.0147 16.4751 16.4763 16.0135 16.8874 15.5003C17.0676 15.2771 17.0276 14.9259 16.7937 14.6916L14.1019 12.0002Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_b_1560_1875"
        x="-3"
        y="-3"
        width="30"
        height="30"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.5" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1560_1875"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1560_1875"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_1560_1875">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(6 6)"
        />
      </clipPath>
    </defs>
  </svg>
)
}

export function UserIcon({ fill = '#000', className }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_112_2474)">
      <path
        d="M21.9841 20.4766C20.5932 14.198 12.1292 16.5906 15.3026 11.866C17.1646 8.97469 17.4975 6.49014 16.291 4.48048C15.3588 2.92676 13.7612 2 12.006 2C10.256 2 8.65386 2.92676 7.72091 4.48048C6.51444 6.49014 6.84726 8.97469 8.71667 11.8768C11.8752 16.5782 3.4062 14.202 2.01589 20.4766C1.93807 20.8282 2.153 21.1783 2.50991 21.2814C2.61108 21.3103 5.06446 21.9959 12.0032 22H12.0038C18.9426 21.9959 21.389 21.3103 21.4901 21.2814C21.847 21.1783 22.0619 20.8281 21.9841 20.4766Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_112_2474">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function ArrowLeft({ fill = '#000' }) {
return (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_78_39204)">
      <path
        d="M2.248 11.3331C2.42574 11.1275 6.90492 6.26709 11.9573 3.15559C12.6443 2.7322 13.5349 3.22297 13.5349 4.02393V8.01525C16.7589 8.49952 20.0064 9.19604 20.523 9.47332C21.4027 9.94332 22 10.7373 22 12.0107C22 13.2875 21.4027 14.0781 20.523 14.5495C20.0064 14.8267 16.7589 15.5239 13.5349 16.0075V19.9635C13.5349 19.9682 13.5349 19.9737 13.5349 19.977C13.5349 20.8552 12.4919 21.3165 11.8298 20.7534C6.83329 17.6398 2.42436 12.8662 2.248 12.6627C1.91733 12.2805 1.91733 11.7152 2.248 11.3331Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_78_39204">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function ArrowLeft16({ fill = '#000' }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_78_39204)">
      <path
        d="M2.248 11.3331C2.42574 11.1275 6.90492 6.26709 11.9573 3.15559C12.6443 2.7322 13.5349 3.22297 13.5349 4.02393V8.01525C16.7589 8.49952 20.0064 9.19604 20.523 9.47332C21.4027 9.94332 22 10.7373 22 12.0107C22 13.2875 21.4027 14.0781 20.523 14.5495C20.0064 14.8267 16.7589 15.5239 13.5349 16.0075V19.9635C13.5349 19.9682 13.5349 19.9737 13.5349 19.977C13.5349 20.8552 12.4919 21.3165 11.8298 20.7534C6.83329 17.6398 2.42436 12.8662 2.248 12.6627C1.91733 12.2805 1.91733 11.7152 2.248 11.3331Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_78_39204">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function Star({ type = 'empty', fill = '#000' }) {
const getFill = (part) => {
  if (type === 'filled') return fill
  if (type === 'half-filled' && part === 'left') return fill
  return fill
}

return (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2334 15.2187L15.8669 14.0625L17.8029 19.9375L11.2334 15.2187ZM21.8969 7.625H13.7406L11.2334 0.0625L8.72627 7.625H0.570038L7.17119 12.3125L4.66402 19.875L11.2652 15.1875L15.3274 12.3125L21.8969 7.625Z"
      fill="white"
    />
  </svg>
)
}
export function StarForMobile({ type = 'empty', fill = '#000' }) {
const getFill = (part) => {
  if (type === 'filled') return fill
  if (type === 'half-filled' && part === 'left') return fill
  return fill
}

return (
  <svg
    width="14.22"
    height="13.25"
    viewBox="0 0 22 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2334 15.2187L15.8669 14.0625L17.8029 19.9375L11.2334 15.2187ZM21.8969 7.625H13.7406L11.2334 0.0625L8.72627 7.625H0.570038L7.17119 12.3125L4.66402 19.875L11.2652 15.1875L15.3274 12.3125L21.8969 7.625Z"
      fill="white"
    />
  </svg>
)
}

export function Iphone({ filled = false, fill = '#000' }) {
return (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_79_40203)">
      <path
        d="M46.0783 9.86156C45.9322 7.63356 44.1069 5.8096 41.6994 5.51193C32.5927 4.38502 23.389 4.38502 14.2797 5.51193C11.8731 5.8096 10.0486 7.63356 9.90252 9.86156C9.12549 21.8007 9.1637 34.9001 9.90252 46.2801C10.0486 48.5097 11.8731 50.3338 14.2797 50.6299C21.849 51.5664 34.1077 51.5694 41.6994 50.6299C44.1069 50.3338 45.9322 48.5097 46.0783 46.2801C46.8436 34.5888 46.8835 22.1333 46.0783 9.86156ZM23.2604 37.8529C23.2421 37.6301 23.0139 37.4477 22.713 37.4179C21.5747 37.3052 20.4242 37.3052 19.2855 37.4179C18.9847 37.4477 18.7566 37.6301 18.7384 37.8529C18.6413 39.0468 18.646 40.3568 18.7384 41.4948C18.7566 41.7177 18.9847 41.9001 19.2855 41.9297C20.2317 42.0234 21.764 42.0237 22.713 41.9297C23.0139 41.9001 23.2421 41.7177 23.2604 41.4948C23.356 40.3256 23.361 39.0801 23.2604 37.8529ZM30.2604 37.8529C30.2421 37.6301 30.0139 37.4477 29.713 37.4179C28.5747 37.3052 27.4242 37.3052 26.2855 37.4179C25.9847 37.4477 25.7566 37.6301 25.7384 37.8529C25.6413 39.0468 25.646 40.3568 25.7384 41.4948C25.7566 41.7177 25.9847 41.9001 26.2855 41.9297C27.2317 42.0234 28.764 42.0237 29.713 41.9297C30.0139 41.9001 30.2421 41.7177 30.2604 41.4948C30.356 40.3256 30.361 39.0801 30.2604 37.8529ZM37.2604 37.8529C37.2421 37.6301 37.0139 37.4477 36.713 37.4179C35.5747 37.3052 34.4242 37.3052 33.2855 37.4179C32.9847 37.4477 32.7566 37.6301 32.7384 37.8529C32.6413 39.0468 32.646 40.3568 32.7384 41.4948C32.7566 41.7177 32.9847 41.9001 33.2855 41.9297C34.2317 42.0234 35.764 42.0237 36.713 41.9297C37.0139 41.9001 37.2421 41.7177 37.2604 41.4948C37.356 40.3256 37.361 39.0801 37.2604 37.8529ZM34.7798 5.70571C34.725 5.26011 34.0405 4.89532 33.1377 4.83578C29.7227 4.6104 26.2713 4.6104 22.8553 4.83578C21.9528 4.89532 21.2686 5.26011 21.2139 5.70571C20.9225 8.09353 20.9368 10.7134 21.2139 12.9894C21.2686 13.4353 21.9528 13.8002 22.8553 13.8594C25.6938 14.0467 30.2908 14.0473 33.1377 13.8594C34.0405 13.8002 34.725 13.4353 34.7798 12.9894C35.0668 10.6511 35.0817 8.16006 34.7798 5.70571ZM40.0299 44.5441C40.0025 44.9238 39.6782 45.2761 39.2504 45.2761C35.3415 45.2761 20.331 45.2761 16.7257 45.2761C16.2968 45.2761 15.9743 44.9237 15.946 44.5441C15.2943 35.187 15.416 20.8968 16.1716 11.9575C16.2025 11.584 16.5285 11.2832 16.9468 11.2376C24.571 10.4448 31.4051 10.4448 39.0291 11.2376C39.4485 11.2832 39.7743 11.584 39.8052 11.9575C40.6722 21.9814 40.7099 34.6432 40.0299 44.5441Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_79_40203">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function HomeIcon({ fill = '#000', className }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_320_7011)">
      <path
        d="M14.4828 7.9876C13.9965 7.29875 13.4544 6.6444 12.8885 6.03567V2.44462C12.8885 2.1991 12.6895 2 12.4441 2H11.1108C10.8654 2 10.6664 2.1991 10.6664 2.44462V3.90635C9.42866 2.84149 8.455 2.1702 8.376 2.11636C8.14946 1.96136 7.85044 1.96136 7.62388 2.11636C7.46591 2.22427 3.72875 4.79906 1.45353 8.06576C1.14653 8.50562 1.46122 9.1139 2.00036 9.1139H3.10164L3.6604 13.0497C3.69989 13.3282 3.90974 13.5518 4.1851 13.609C6.6847 14.1272 9.28434 14.1335 11.8148 13.609C12.0901 13.5518 12.3 13.3282 12.3395 13.0497L12.8982 9.1139H13.9906C13.9937 9.11368 13.9963 9.1139 13.9995 9.1139C14.5871 9.1139 14.8828 8.40834 14.4828 7.9876ZM9.72335 11.8083C9.71056 12.0243 9.54368 12.1997 9.32863 12.2236C8.46058 12.3193 7.57273 12.3229 6.67126 12.2236C6.45621 12.1997 6.28933 12.0243 6.27653 11.8083L6.16976 10.0299C6.15436 9.77385 6.35801 9.55852 6.61333 9.55852H9.38658C9.64187 9.55852 9.84552 9.77385 9.83012 10.0299L9.72335 11.8083Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_320_7011">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function BankNoteFlyIcon({ fill = '#000', className }) {
return (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_320_19404)">
      <path
        d="M9.07238 2.11763C9.26987 1.97112 9.55098 1.99606 9.73159 2.17667L13.8609 6.30594C14.0415 6.48658 14.0664 6.76767 13.9199 6.96517C13.0208 8.17549 12.0252 9.3293 10.9603 10.3942C9.89532 11.4592 8.74606 12.4503 7.53598 13.3491C7.33825 13.4958 7.05738 13.4707 6.87675 13.2901L5.84221 12.2544C5.82568 12.3387 5.79006 12.4195 5.73503 12.489L4.47818 13.8461C4.38479 13.9461 4.25798 14.0014 4.12576 13.9998L4.06419 13.9951C3.88921 13.9698 3.7366 13.8457 3.66686 13.6662C3.58839 13.4642 3.6304 13.2323 3.77314 13.0795L5.03003 11.7278C5.0838 11.6782 5.14489 11.6432 5.20905 11.6226L2.74748 9.16079C2.56686 8.98017 2.5417 8.69929 2.68843 8.50158C4.51509 6.04163 6.69107 3.88596 9.07238 2.11763ZM2.73522 11.6518C2.93169 11.4705 3.22594 11.4844 3.41063 11.6838C3.59531 11.8832 3.60821 12.2009 3.44023 12.413L2.18337 13.77C2.08998 13.8701 1.96317 13.9254 1.83095 13.9238L1.76938 13.9191C1.5944 13.8938 1.44179 13.7697 1.37205 13.5901C1.29358 13.3882 1.33559 13.1563 1.47833 13.0035L2.73522 11.6518ZM8.18731 4.21376C6.65168 5.50916 6.07518 6.08566 4.77977 7.62129C5.29699 8.29959 5.35467 9.23404 4.924 9.94909L6.08823 11.1133C6.80326 10.6827 7.73773 10.7403 8.41602 11.2575C9.9275 9.98167 10.5477 9.36148 11.8236 7.85C11.3063 7.17171 11.2534 6.23247 11.6841 5.51742L10.5199 4.3532C9.80485 4.78387 8.8656 4.73098 8.18731 4.21376ZM5.98452 9.11997C6.1879 8.91658 6.62832 8.94521 6.86005 9.17694C7.09204 9.40893 7.12041 9.84908 6.91702 10.0525C6.71386 10.2556 6.25323 10.2477 6.02124 10.0157C5.78952 9.78402 5.78136 9.32312 5.98452 9.11997ZM7.00823 6.43312C7.65162 5.78974 8.75313 5.84792 9.46857 6.56336C10.184 7.2788 10.2422 8.38033 9.59881 9.0237C8.95544 9.66707 7.85438 9.60843 7.13894 8.89299C6.4235 8.17755 6.36486 7.0765 7.00823 6.43312ZM9.69874 5.40575C9.93057 5.17391 10.327 5.19492 10.5845 5.45248C10.842 5.71001 10.8631 6.10643 10.6312 6.33825C10.3999 6.56963 10.0035 6.54859 9.74592 6.29106C9.48837 6.03351 9.46736 5.63713 9.69874 5.40575Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_320_19404">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function BriefcaseIcon({ fill = '#000', className }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_320_5084)">
      <path
        d="M14.1919 5.72904C14.0963 5.33567 13.7384 5.05795 13.3267 5.05795H11.5534V3.12016C11.5534 2.70076 11.2511 2.34024 10.8319 2.26174C8.96767 1.91275 7.02461 1.91275 5.16036 2.26174C4.74119 2.34024 4.43692 2.70076 4.43692 3.12016V5.05795H2.67363C2.2619 5.05795 1.90399 5.33567 1.8084 5.72904C1.17686 8.33198 1.17512 10.2337 1.80364 12.9403C1.8853 13.2919 2.1789 13.5581 2.54247 13.6102C6.16342 14.1297 9.83342 14.1302 13.4578 13.6102C13.8214 13.5581 14.115 13.2919 14.1967 12.9403C14.8252 10.2333 14.8235 8.33198 14.1919 5.72904ZM9.77428 5.05795H6.21604V3.81812C7.55038 3.66198 8.43994 3.66198 9.77428 3.81812V5.05795Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_320_5084">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function NotificationIcon({ fill = '#000', className }) {
return (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4141_25302)">
      <path
        d="M50.0885 38.0124C49.7989 37.7937 42.8262 32.5437 42.8262 21.7779C42.8262 7.63506 34.8509 4.66675 28.006 4.66675C21.1611 4.66675 13.1858 7.61982 13.1858 21.7626C13.1858 32.5285 6.21248 37.7937 5.94148 37.9987C5.01789 38.6763 4.54497 39.7563 4.69556 40.844C4.84597 41.9302 5.59806 42.8629 6.67639 43.299C6.94739 43.4099 12.1989 45.4864 20.8454 46.3203C21.7682 49.2127 24.6043 51.3334 28.0012 51.3334C31.398 51.3334 34.2333 49.2127 35.1561 46.3219C43.8093 45.4879 49.0648 43.4099 49.3358 43.299C50.4068 42.8659 51.1465 41.9363 51.3043 40.8577C51.4623 39.7792 50.9952 38.6961 50.0885 38.0124Z"
        fill="#5D1CD3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4141_25302">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function BadgeIcon({ fill = '#000', className }) {
return (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0452 20.1188C17.3725 21.9046 13.4694 23.1721 9.44795 23.8851L9.22691 23.9242C7.07124 24.3063 4.92253 23.2165 3.95845 21.2516C2.15942 17.5844 0.878545 13.6854 0.152788 9.6661L0.0783884 9.25378C-0.31233 7.08923 0.784706 4.929 2.76374 3.96684L2.94422 3.879C6.61692 2.09341 10.52 0.825731 14.5415 0.112934L14.7507 0.0757337C16.9122 -0.307305 19.0657 0.789251 20.0259 2.76228L20.1188 2.95308C21.9056 6.62387 23.1737 10.5251 23.887 14.5443L23.9242 14.7534C24.3075 16.9138 23.2102 19.0661 21.2362 20.0259L21.0452 20.1188Z"
      fill="#50E3C2"
    />
    <path
      d="M11.7842 16V9.784L9.78019 10.96V9.172L11.8922 7.936H13.5002V16H11.7842Z"
      fill="white"
    />
  </svg>
)
}
export function EmailIcon({ fill = '#000', className }) {
return (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4703_27107)">
      <path
        d="M21.1885 35.3685L4.66797 22.8125V43.4926C4.66797 44.3157 5.27714 45.013 6.1008 45.1293C20.4428 47.1529 35.191 47.205 49.9027 45.1293C50.723 45.0131 51.3346 44.3157 51.3346 43.4926V22.8092L34.8116 35.3685C30.9815 38.2804 24.9999 38.2709 21.1885 35.3685ZM49.9027 10.8634C35.4431 8.82319 20.5601 8.82319 6.10047 10.8634C5.2768 10.9796 4.66797 11.677 4.66797 12.5001V14.8632C4.66797 15.4378 5.25439 16.3933 6.50755 17.6023L24.2291 31.0749C26.2376 32.6019 29.7631 32.6019 31.7684 31.0749L49.5055 17.5958C50.749 16.3932 51.3346 15.441 51.3346 14.8665V12.5001C51.3346 11.677 50.7231 10.9796 49.9027 10.8634Z"
        fill="#5D1CD3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4703_27107">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function InboxIcon({ fill = '#000', className }) {
return (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4703_26726)">
      <path
        d="M26.9888 27.2615C27.5717 27.6954 28.3991 27.6954 28.9849 27.2615C29.2664 27.0497 35.96 22.1887 40.2446 16.1936C40.9536 15.2003 40.2063 13.8459 38.9107 13.8459H33.3107C32.7187 10.7925 31.6066 6.5614 31.1982 6.01935C29.8497 4.21562 26.131 4.21615 24.783 6.01935C24.3792 6.56125 23.2625 10.7925 22.6751 13.8459H17.0614C15.7743 13.8459 15.0154 15.1937 15.729 16.1936C20.0121 22.1886 26.7057 27.0497 26.9888 27.2615ZM50.3889 30.1181C48.1083 22.9521 47.7457 22.6844 46.9503 22.0976C46.4058 21.6965 45.7419 21.4795 45.0598 21.4795H42.3768L43.9493 32.0279C44.0057 32.1859 44.0364 32.1728 44.0364 32.3495C44.0364 33.1927 43.3359 33.6932 42.4701 33.6932C42.4624 33.6932 42.4518 33.6932 42.4394 33.6932H34.4074C34.1137 36.7467 30.7563 38.1646 27.9998 38.1646C25.2435 38.1646 22.0144 36.7467 21.7207 33.6932H13.4072C12.9544 33.6932 12.5245 33.6855 12.2263 33.3538C11.9296 33.0214 11.7934 32.6714 11.8546 32.2346L13.3108 21.4795H10.9123C10.1827 21.4795 9.47597 21.7278 8.91459 22.1811C8.19869 22.7588 7.8729 23.0221 5.61368 30.1181C4.43282 33.826 4.07781 41.3014 6.21163 44.5031C9.69447 49.7299 29.6079 48.9602 28.0182 48.9602C47.0773 48.9602 49.0078 45.681 49.7909 44.5024C51.9248 41.3014 51.5698 33.8261 50.3889 30.1181Z"
        fill="#5D1CD3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4703_26726">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function HelpIcon({ fill = '#000' }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_320_8706)">
      <path
        d="M8.00341 1.33325C4.32005 1.33325 1.3335 4.31721 1.3335 7.99992C1.3335 11.6822 4.32005 14.6666 8.00341 14.6666C11.6851 14.6666 14.6668 11.6822 14.6668 7.99992C14.6668 4.31721 11.6851 1.33325 8.00341 1.33325ZM7.81925 13.0181C7.2813 13.0181 6.80016 12.5377 6.80016 11.9999C6.80016 11.4621 7.28132 10.9817 7.81925 10.9817C8.35718 10.9817 8.83834 11.4621 8.83834 11.9999C8.83834 12.5377 8.35721 13.0181 7.81925 13.0181ZM9.26437 8.3849C8.99311 8.63054 8.68148 8.95739 8.60139 9.32634C8.60139 9.32763 8.60228 9.32892 8.60228 9.33025C8.60228 9.58025 8.40086 9.80896 8.15242 9.80896C8.15086 9.80896 8.14979 9.80812 8.14826 9.80812C8.14826 9.80852 8.14804 9.80852 8.14804 9.80852L7.24851 9.80896C7.00002 9.80896 6.79864 9.58025 6.79864 9.33025C6.79864 9.32372 6.80233 9.31807 6.80255 9.31159C6.84075 7.9383 8.29973 7.35412 8.96531 6.53639C9.43704 5.95639 8.97991 5.00514 7.96768 5.00514C7.39324 5.00514 6.91973 5.4739 6.80493 5.88581C6.80448 5.88581 6.80424 5.88581 6.80384 5.88536C6.76326 6.09367 6.58964 6.25341 6.37086 6.25341C6.36915 6.25341 6.36786 6.25256 6.36611 6.25256C6.36588 6.25296 6.36566 6.25296 6.36566 6.25296L5.44944 6.25341C5.12788 6.25341 4.89682 5.91727 5.04711 5.60759C5.34766 4.64145 6.31751 3.50776 7.90497 3.50776C9.86346 3.50776 10.8034 4.87454 10.8034 6.03119C10.8034 7.01054 10.0339 7.69205 9.26437 8.3849Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_320_8706">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function InfoIcon({ fill = '#000' }) {
return (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_320_6557)">
      <path
        d="M12.0049 2C6.47983 2 2 6.47593 2 12C2 17.5235 6.47983 22 12.0049 22C17.5273 22 22 17.5235 22 12C22 6.47593 17.5273 2 12.0049 2ZM11.9993 5.1432C12.8096 5.1432 13.5231 5.9004 13.5231 6.69333C13.5231 7.49087 12.8096 8.19013 11.9993 8.19013C11.1898 8.19013 10.4762 7.49087 10.4762 6.69333C10.4762 5.9004 11.1898 5.1432 11.9993 5.1432ZM14.1335 17.3333C14.1335 17.6999 13.8333 18 13.4668 18C13.2389 18 13.0355 18 12.8466 18C11.641 18 11.1963 18 11.1542 18C11.1522 18 11.1498 18 11.1498 18C10.9617 18 10.7596 18 10.5332 18C10.1667 18 9.86653 17.6999 9.86653 17.3333V16.6667C9.86653 16.3001 10.1667 16 10.5332 16V12C10.1667 12 9.86653 11.6999 9.86653 11.3333V10.6667C9.86653 10.3001 10.1667 10 10.5332 10C13.0368 10 11.3097 10 12.8067 10C13.1732 10 13.4733 10.3001 13.4733 10.6667L13.4668 16C13.8333 16 14.1335 16.3001 14.1335 16.6667V17.3333Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_320_6557">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function CreditCardIcon({ fill = '#000' }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_367_9031)">
      <path
        d="M4.42582 11.0646C4.96512 11.0646 5.0958 10.6582 5.46564 10.6582H6.04936C6.4192 10.6582 6.54945 11.0646 7.08918 11.0646C7.56052 11.0646 7.94298 10.6569 7.94342 10.154C7.94298 9.65107 7.56052 9.24333 7.08918 9.24333C6.54945 9.24333 6.4192 9.64975 6.04936 9.64975H5.46564C5.0958 9.64975 4.96512 9.24333 4.42582 9.24333C3.95448 9.24333 3.57245 9.65107 3.57158 10.154C3.57245 10.6569 3.95448 11.0646 4.42582 11.0646ZM12.7269 2.86672C8.06375 2.45839 3.67558 2.78795 3.183 2.87314C2.13884 3.04589 1.33337 3.9859 1.33337 5.03527V10.9581C1.33337 12.1243 2.31542 13.0471 3.2331 13.1311C8.00512 13.5489 12.3309 13.2026 12.777 13.1247C13.8212 12.9519 14.6667 12.0075 14.6667 10.9581V5.03527C14.6667 3.87808 13.6474 2.95104 12.7269 2.86672ZM13.3416 10.2914C13.3416 10.6725 12.9783 11.7542 12.5836 11.8316C9.53429 12.0966 6.42574 12.0966 3.37644 11.8316C2.98178 11.7542 2.62718 11.3481 2.62718 10.967V7.66603H13.3416V10.9581V10.2914ZM13.3816 5.38942H2.62716V5.03527C2.62716 4.65422 2.98174 4.24356 3.37642 4.1662C6.42574 3.90116 9.57872 3.90116 12.628 4.1662C13.0227 4.24356 13.3816 4.65422 13.3816 5.03527V5.38942Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_367_9031">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function CreditCardIcon24({ fill = '#000' }) {
return (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clipPath="url(#clip0_44_1795)">
      <path d="M6.63867 16.5968C7.44762 16.5968 7.64364 15.9872 8.19839 15.9872H9.07399C9.62874 15.9872 9.82412 16.5968 10.6337 16.5968C11.3407 16.5968 11.9144 15.9852 11.9151 15.2308C11.9144 14.4765 11.3407 13.8649 10.6337 13.8649C9.82412 13.8649 9.62874 14.4745 9.07399 14.4745H8.19839C7.64364 14.4745 7.44762 13.8649 6.63867 13.8649C5.93166 13.8649 5.35861 14.4765 5.3573 15.2308C5.35861 15.9852 5.93166 16.5968 6.63867 16.5968ZM19.0903 4.29996C12.0956 3.68746 5.51331 4.1818 4.77445 4.30959C3.2082 4.56871 2 5.97872 2 7.55279V16.4371C2 18.1863 3.47307 19.5705 4.84959 19.6966C12.0076 20.3232 18.4963 19.8037 19.1654 19.6869C20.7317 19.4278 22 18.0111 22 16.4371V7.55279C22 5.81699 20.4711 4.42644 19.0903 4.29996ZM20.0123 15.4371C20.0123 16.0086 19.4673 17.6312 18.8753 17.7474C14.3014 18.1448 9.63854 18.1448 5.0646 17.7474C4.47261 17.6312 3.94071 17.022 3.94071 16.4504V11.4989H20.0123V16.4371V15.4371ZM20.0724 8.08401H3.94067V7.55279C3.94067 6.9812 4.47255 6.36522 5.06457 6.24918C9.63854 5.85162 14.368 5.85162 18.942 6.24918C19.534 6.36522 20.0724 6.9812 20.0724 7.55279V8.08401Z" fill="#5D1CD3"/>
    </g>
    <defs>
      <clipPath id="clip0_44_1795">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)
}
export function FoodIcon({ fill = '#000' }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_373_19045)">
      <path
        d="M14.6546 5.47118L14.1906 1.7378C14.1631 1.51059 13.966 1.33505 13.7267 1.33505C13.4681 1.33505 13.2682 1.54024 13.2682 1.79302V5.01141H12.3201V1.79302C12.3201 1.53891 12.1101 1.33325 11.8506 1.33325C11.5911 1.33325 11.3903 1.53891 11.3903 1.79302V5.01141H10.4422V1.79302C10.4422 1.56539 10.2689 1.36737 10.0323 1.33863C9.7765 1.30723 9.54268 1.48502 9.51056 1.73601L9.05302 5.48916C8.98701 6.04498 9.17818 7.14323 10.6943 7.65822C10.4724 9.22254 10.1607 11.6902 10.1607 13.2064C10.1607 13.9635 10.9117 14.6666 11.8506 14.6666C12.7886 14.6666 13.5405 13.9635 13.5405 13.2064C13.5405 11.6902 13.2288 9.223 13.0069 7.65822C14.4355 7.17376 14.7353 6.12852 14.6546 5.47118ZM4.81679 1.33325C2.64457 1.33325 1.87572 4.08516 2.01602 5.86314C2.09808 6.90751 2.58776 7.71348 3.60553 8.05334C3.39051 9.61495 3.12688 11.8096 3.12688 13.2064C3.12688 13.9635 3.87785 14.6666 4.81679 14.6666C5.75482 14.6666 6.5067 13.9635 6.5067 13.2064C6.5067 11.8101 6.24262 9.61541 6.0276 8.05334C7.04586 7.7139 7.5355 6.90751 7.61756 5.86314C7.75784 4.08516 6.98903 1.33325 4.81679 1.33325Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_373_19045">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function LightIcon({ fill = '#000' }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_373_9145)">
      <path
        d="M4.18214 3.94209L9.01067 3.0981C9.49453 3.01346 9.81809 2.55285 9.73341 2.06877C9.64872 1.58558 9.18875 1.26301 8.70401 1.34637L3.87552 2.19032C3.39167 2.275 3.0681 2.73561 3.15279 3.21924C3.25268 3.7897 3.79084 4.00895 4.18214 3.94209ZM11.8365 6.30509L3.89678 7.69606C3.41293 7.78115 3.08939 8.24176 3.17449 8.72539C3.21837 8.97679 3.3656 9.18213 3.56321 9.31194L5.37658 10.8245C5.49645 11.6007 5.612 12.2041 5.71972 12.6022C6.08108 13.9433 6.5888 14.6666 8.11595 14.6666C9.64219 14.6666 10.1947 13.9546 10.5113 12.6027C10.7836 11.4409 10.9365 10.3295 11.0655 9.37618L7.13261 9.97269L6.1037 9.11482L12.144 8.05638C12.6278 7.97173 12.9514 7.51113 12.8663 7.0275C12.7816 6.54386 12.322 6.21911 11.8365 6.30509ZM13.3193 4.16784C13.2333 3.68465 12.7746 3.36252 12.2873 3.4489L3.39992 5.03566C2.91646 5.12163 2.59419 5.58353 2.68065 6.06716C2.80834 6.7809 3.46636 6.83038 3.71263 6.7861L12.6 5.19934C13.0834 5.11297 13.4057 4.65103 13.3193 4.16784Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_373_9145">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function BankNoteIcon({ fill = '#000', className }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_377_17236)">
      <path
        d="M4.46212 7.17992C4.07428 7.17992 3.64212 7.59168 3.64212 7.99853C3.64212 8.40583 4.07428 8.81714 4.46212 8.81714C4.85041 8.81714 5.24348 8.40583 5.24348 7.99853C5.24348 7.59168 4.85041 7.17992 4.46212 7.17992ZM8.00403 5.71992C6.77577 5.71992 5.78074 6.73798 5.78074 7.99409C5.78074 9.25021 6.77577 10.2683 8.00403 10.2683C9.23229 10.2683 10.2282 9.25021 10.2282 7.99409C10.2282 6.73798 9.23232 5.71992 8.00403 5.71992ZM10.7529 7.99853C10.7529 8.45068 11.1112 8.81714 11.5529 8.81714C11.9955 8.81714 12.3538 8.45068 12.3538 7.99853C12.3538 7.54633 11.9955 7.17992 11.5529 7.17992C11.1112 7.17992 10.7529 7.54633 10.7529 7.99853ZM14.0937 3.74355C10.1327 3.20544 5.99791 3.18761 1.90613 3.74355C1.57735 3.78829 1.33325 4.05697 1.33325 4.37408V11.6239C1.33325 11.9411 1.57735 12.2097 1.90613 12.2545C3.91922 12.5277 5.96228 12.6666 7.99536 12.6666C10.0284 12.6666 12.0802 12.5277 14.0937 12.2545C14.4221 12.2097 14.6666 11.9411 14.6666 11.6239V4.37408C14.6666 4.05697 14.4221 3.78829 14.0937 3.74355ZM13.3415 9.02084C12.2478 9.27049 11.4018 10.1414 11.248 11.1909C8.58734 11.3978 7.40336 11.3978 4.74269 11.1909C4.58894 10.1414 3.75199 9.27049 2.65838 9.02084V6.97679C3.75202 6.72714 4.58894 5.85618 4.74269 4.80669C7.44505 4.59581 8.54565 4.59581 11.248 4.80669C11.4018 5.85618 12.2478 6.72714 13.3415 6.97679V9.02084Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_377_17236">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function Links({ fill = '#000', className }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3380_2614)">
      <path
        d="M13.2904 2.71531C11.4862 0.90331 8.77594 0.769403 6.61648 2.93393C4.13631 5.42576 4.70424 8.60094 7.14909 10.2317C7.51018 9.80489 8.04772 8.9091 7.86225 7.49055C8.94556 8.68165 9.03383 10.2281 7.77067 11.4426C6.479 12.6845 5.27245 12.5962 4.34099 11.6617C3.4895 10.8075 3.42662 9.75372 4.11908 8.75423C3.71856 7.87285 3.55685 6.93359 3.64036 5.98978C1.09453 7.89412 0.463843 11.0229 2.72022 13.2864C4.3306 14.9001 6.69088 15.1926 8.7079 13.6622C9.41701 13.1238 10.038 12.4679 10.4584 11.6772C11.4421 9.83469 11.0705 7.81409 9.61192 6.37796C9.05905 5.82297 8.41287 5.429 7.72569 5.20721C8.2392 4.39293 9.16535 3.63103 10.1203 3.63103C11.247 3.63103 12.3765 4.75875 12.3765 5.8901C12.377 6.34293 12.2081 6.80876 11.8874 7.26177C12.2721 8.12023 12.4487 9.04191 12.3666 10.0119C15.0444 8.01007 15.4253 4.8502 13.2904 2.71531Z"
        fill="#5D1CD3"
      />
    </g>
    <defs>
      <clipPath id="clip0_3380_2614">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}

export function SearchIcon({ fill = '#000' }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_394_17980)">
      <path
        d="M6.9082 1.33325C9.98705 1.33325 12.4832 3.82884 12.4832 6.90805C12.4832 7.74405 12.294 8.53388 11.9644 9.24554L14.4024 12.5264C14.7455 12.989 14.7636 13.64 14.4022 14.1259C13.9603 14.7199 13.1207 14.8434 12.5266 14.4018L9.24704 11.9635C8.53497 12.2934 7.74446 12.4828 6.9082 12.4828C3.82931 12.4828 1.33317 9.98726 1.33317 6.9085C1.33317 3.82884 3.82931 1.33325 6.9082 1.33325ZM6.90771 10.7732C9.04277 10.7736 10.7735 9.04324 10.7735 6.90827C10.7735 4.7733 9.04277 3.04293 6.90771 3.04293C4.77357 3.04293 3.04292 4.7733 3.04292 6.90827C3.04292 9.04324 4.77265 10.7736 6.90771 10.7732Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_394_17980">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="matrix(-1 0 0 1 16 0)"
        />
      </clipPath>
    </defs>
  </svg>
)
}
export function CheckIcon({ fill = '#000', className }) {
return (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg "
    className={className}
  >
    <g clipPath="url(#clip0_112_2098)">
      <path
        d="M21.7047 4.96668C20.8849 4.24697 20 3.62672 19.0456 3.10445C18.6298 2.87331 18.0701 3.03711 17.7588 3.48404L9.51904 14.1924L6.24319 10.6105C5.93038 10.1636 5.36779 9.99679 4.95127 10.2265C4.00056 10.7502 3.11273 11.7457 2.29577 12.4632C1.93481 12.7771 1.89972 13.3614 2.21541 13.8105C2.21541 13.8105 6.8723 18.9782 7.5775 19.9627C8.5947 21.3824 10.4844 21.3086 11.4628 19.9627C12.187 18.9665 21.7881 6.30963 21.7881 6.30963C22.1008 5.8627 22.0628 5.28051 21.7047 4.96668Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_112_2098">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function PlusIcon({ fill = '#000', className }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_112_2373)">
      <path
        d="M21.9103 10.1584C21.8587 9.61679 21.396 9.20255 20.8427 9.20255H14.7974V3.15728C14.7974 2.60395 14.3832 2.14129 13.8424 2.08967C12.6131 1.97011 11.3813 1.97011 10.1511 2.08967C9.60955 2.14129 9.19531 2.60395 9.19531 3.15728V9.20255H3.15708C2.60375 9.20255 2.14101 9.61679 2.09027 10.1584C1.96991 11.3885 1.96991 12.6202 2.09027 13.8496C2.14101 14.3905 2.60371 14.8047 3.15708 14.8047H9.19531V20.8429C9.19531 21.3962 9.60955 21.859 10.1511 21.9097C11.3812 22.0301 12.613 22.0301 13.8423 21.9097C14.3832 21.859 14.7974 21.3962 14.7974 20.8429V14.8047H20.8427C21.396 14.8047 21.8587 14.3905 21.9103 13.8496C22.0299 12.6203 22.0299 11.3885 21.9103 10.1584Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_112_2373">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function CalenderIcon({ fill = '#000', className }) {
return (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_112_2074)">
      <path
        d="M13.2857 11.4031H10.7143V13.8039H13.2857V11.4031ZM17.1429 15.0044H14.5714V17.4052H17.1429V15.0044ZM17.1429 11.4031H14.5714V13.8039H17.1429V11.4031ZM20.2278 5.46126C20.1462 5.44601 18.9911 5.23209 17.1429 5.05155V4.20044C17.1429 3.5375 16.5672 3 15.8571 3C15.1471 3 14.5746 3.5375 14.5746 4.20044L14.5777 6.60131C14.5777 6.95592 14.7397 7.27187 15.0014 7.49167C14.0294 7.55428 13.2857 6.83756 13.2857 6.00109V4.81824C12.0904 4.78799 10.8717 4.79405 9.42857 4.86398V4.20044C9.42857 3.5375 8.85289 3 8.14286 3C7.43282 3 6.86029 3.5375 6.86029 4.20044V6.60131C6.86029 6.95592 7.02538 7.27187 7.28715 7.49167C6.31509 7.55428 5.57143 6.83756 5.57143 6.00109V5.19278C4.48532 5.32819 3.83244 5.44955 3.7722 5.46126C3.32271 5.54625 3 5.9155 3 6.3434V19.4509C3 19.8747 3.31641 20.2416 3.76089 20.3307C8.15816 21.2158 15.77 21.2303 20.2391 20.3307C20.6836 20.2416 21 19.8747 21 19.4509V6.3434C21 5.9155 20.6773 5.54625 20.2278 5.46126ZM19.0714 18.7763C14.6657 19.4541 9.54583 19.4845 4.92857 18.7757V10.1909H19.0714V18.7763ZM9.42857 15.0044H6.85714V17.4052H9.42857V15.0044ZM13.2857 15.0044H10.7143V17.4052H13.2857V15.0044Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_112_2074">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function CalenderIconForMobile({ fill = '#000', className }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_112_2074)">
      <path
        d="M13.2857 11.4031H10.7143V13.8039H13.2857V11.4031ZM17.1429 15.0044H14.5714V17.4052H17.1429V15.0044ZM17.1429 11.4031H14.5714V13.8039H17.1429V11.4031ZM20.2278 5.46126C20.1462 5.44601 18.9911 5.23209 17.1429 5.05155V4.20044C17.1429 3.5375 16.5672 3 15.8571 3C15.1471 3 14.5746 3.5375 14.5746 4.20044L14.5777 6.60131C14.5777 6.95592 14.7397 7.27187 15.0014 7.49167C14.0294 7.55428 13.2857 6.83756 13.2857 6.00109V4.81824C12.0904 4.78799 10.8717 4.79405 9.42857 4.86398V4.20044C9.42857 3.5375 8.85289 3 8.14286 3C7.43282 3 6.86029 3.5375 6.86029 4.20044V6.60131C6.86029 6.95592 7.02538 7.27187 7.28715 7.49167C6.31509 7.55428 5.57143 6.83756 5.57143 6.00109V5.19278C4.48532 5.32819 3.83244 5.44955 3.7722 5.46126C3.32271 5.54625 3 5.9155 3 6.3434V19.4509C3 19.8747 3.31641 20.2416 3.76089 20.3307C8.15816 21.2158 15.77 21.2303 20.2391 20.3307C20.6836 20.2416 21 19.8747 21 19.4509V6.3434C21 5.9155 20.6773 5.54625 20.2278 5.46126ZM19.0714 18.7763C14.6657 19.4541 9.54583 19.4845 4.92857 18.7757V10.1909H19.0714V18.7763ZM9.42857 15.0044H6.85714V17.4052H9.42857V15.0044ZM13.2857 15.0044H10.7143V17.4052H13.2857V15.0044Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_112_2074">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function CreditReportIcon({ fill = '#000', className }) {
return (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_112_2114)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7C7.58172 7 4 10.5817 4 15C4 16.1046 3.10457 17 2 17C0.89543 17 0 16.1046 0 15C0 8.37258 5.37258 3 12 3C18.6274 3 24 8.37258 24 15C24 16.1046 23.1046 17 22 17C20.8954 17 20 16.1046 20 15C20 10.5817 16.4183 7 12 7ZM11.8525 15.0036C10.2641 15.0805 9 16.3926 9 18C9 19.6569 10.3431 21 12 21C13.6569 21 15 19.6569 15 18C15 17.2742 14.7423 16.6087 14.3134 16.0898L15.9643 11.0256C16.0616 10.7486 15.9565 10.4327 15.6926 10.2699C15.3844 10.0798 14.9777 10.1691 14.7834 10.4704L11.8525 15.0036Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_112_2114">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function Simple({ fill = '#000', className }) {
return (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1815_27533)">
      <path
        d="M12.0022 2C6.47778 2 2 6.47778 2 12C2 17.5222 6.47778 22 12 22C17.5222 22 22 17.5222 22 12C22 6.47778 17.5244 2 12.0022 2ZM7.99556 8.52444C8.86667 8.52444 9.57111 9.23111 9.57111 10.1C9.57111 10.9689 8.86444 11.6756 7.99556 11.6756C7.12667 11.6756 6.42 10.9689 6.42 10.1C6.42 9.23111 7.12444 8.52444 7.99556 8.52444ZM17.4422 14.6622C16.8711 16.6489 14.6533 18.1289 12.0022 18.1289C9.35111 18.1289 7.13111 16.6489 6.56222 14.6622C6.41778 14.1578 6.79778 13.6556 7.32222 13.6556H16.6844C17.2067 13.6556 17.5867 14.1578 17.4422 14.6622ZM16.0067 11.6778C15.1356 11.6778 14.4311 10.9711 14.4311 10.1022C14.4311 9.23333 15.1378 8.52667 16.0067 8.52667C16.8756 8.52667 17.5822 9.23333 17.5822 10.1022C17.5822 10.9711 16.8778 11.6778 16.0067 11.6778Z"
        fill="#5D1CD3"
      />
    </g>
    <defs>
      <clipPath id="clip0_1815_27533">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function ChatIcon({ fill = '#000', className }) {
return (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clipPath="url(#clip0_67_1627)">
    <path d="M21.7191 5.6366C21.4528 4.02573 19.6954 2.47654 18.061 2.29686C14.0206 1.90105 9.97946 1.90105 5.93902 2.29686C4.30466 2.47654 2.54789 4.02608 2.28095 5.6366C1.90635 8.11036 1.90635 11.7737 2.28095 14.2475C2.54789 15.8583 4.30466 17.4072 5.93902 17.5872C6.51732 17.644 7.09569 17.6743 7.67398 17.7146V21.2946C7.67398 21.9193 8.44943 22.2366 8.90224 21.793L13.1865 17.7586C14.8118 17.7277 16.4363 17.6498 18.061 17.4908C19.6954 17.3108 21.4528 15.8583 21.7191 14.2475C22.0936 11.7737 22.0936 8.11036 21.7191 5.6366Z" fill="#5D1CD3"/>
  </g>
  <defs>
    <clipPath id="clip0_67_1627">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
)
}
export function ListIcon({ fill = '#000', className }) {
return (
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clipPath="url(#clip0_67_1633)">
    <path d="M3.72471 10.2609C2.77208 10.2609 2 11.0394 2 12C2 12.9606 2.77208 13.7391 3.72471 13.7391C4.67668 13.7391 5.44941 12.9606 5.44941 12C5.44941 11.0394 4.67668 10.2609 3.72471 10.2609ZM3.72471 16.5217C2.77208 16.5217 2 17.3002 2 18.2609C2 19.2215 2.77208 20 3.72471 20C4.67668 20 5.44941 19.2215 5.44941 18.2609C5.44941 17.3002 4.67668 16.5217 3.72471 16.5217ZM8.88399 7.47826H21.0457C21.5038 7.47826 21.8838 7.16849 21.9283 6.76362C22.0239 5.84445 22.0239 5.63381 21.9283 4.71464C21.8838 4.30908 21.5038 4 21.0457 4H8.88399C8.51077 4 8.20894 4.32612 8.20894 4.71464C8.20894 5.10261 8.20894 6.33697 8.20894 6.76362C8.20894 7.19089 8.56399 7.47826 8.88399 7.47826ZM3.72471 4C2.77208 4 2 4.7785 2 5.73913C2 6.69976 2.77208 7.47826 3.72471 7.47826C4.67668 7.47826 5.44941 6.69976 5.44941 5.73913C5.44941 4.7785 4.67668 4 3.72471 4ZM21.0457 16.5217H8.88399C8.51077 16.5217 8.20894 16.8479 8.20894 17.2364C8.20894 17.6243 8.20894 18.8587 8.20894 19.2854C8.20894 19.7126 8.56399 20 8.88399 20H21.0457C21.5038 20 21.8838 19.6902 21.9283 19.2854C22.0239 18.3662 22.0239 18.1555 21.9283 17.2364C21.8838 16.8308 21.5038 16.5217 21.0457 16.5217ZM21.0457 10.2609H8.88399C8.51077 10.2609 8.20894 10.587 8.20894 10.9755C8.20894 11.3635 8.20894 12.5978 8.20894 13.0245C8.20894 13.4518 8.56399 13.7391 8.88399 13.7391H21.0457C21.5038 13.7391 21.8838 13.4294 21.9283 13.0245C22.0239 12.1053 22.0239 11.8947 21.9283 10.9755C21.8838 10.5699 21.5038 10.2609 21.0457 10.2609Z" fill="#5D1CD3"/>
  </g>
  <defs>
    <clipPath id="clip0_67_1633">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
)
}
export function AppStore({ fill = '#000', className }) {
return (
  <svg
    width="144"
    height="48"
    viewBox="0 0 144 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2669_62827)">
      <path
        d="M132.527 0.000488281H11.4679C11.0266 0.000488281 10.5906 0.000488281 10.1505 0.00304427C9.7821 0.00544426 9.41663 0.0124162 9.04468 0.0182842C8.23663 0.0277664 7.43049 0.0986555 6.63325 0.230336C5.83713 0.364882 5.06595 0.618541 4.34579 0.982733C3.62651 1.35001 2.96928 1.82724 2.39795 2.39712C1.82362 2.9654 1.34488 3.62225 0.980121 4.34242C0.614357 5.06116 0.360735 5.83135 0.228015 6.6264C0.0940334 7.42044 0.0219365 8.22364 0.0123717 9.02879C0.0012044 9.39671 2.50977e-05 9.76585 -0.00585938 10.1338V37.8708C2.50977e-05 38.2434 0.0012044 38.6044 0.0123717 38.9771C0.0219394 39.7822 0.0940363 40.5854 0.228015 41.3794C0.360369 42.1749 0.614006 42.9455 0.980121 43.6645C1.34471 44.3824 1.82353 45.0366 2.39795 45.6017C2.96712 46.1741 3.62477 46.6517 4.34579 47.0161C5.06594 47.3813 5.83704 47.6365 6.63325 47.7731C7.43062 47.9037 8.23668 47.9746 9.04468 47.9852C9.41663 47.9934 9.7821 47.9981 10.1505 47.9981C10.5906 48.0005 11.0266 48.0005 11.4679 48.0005H132.527C132.959 48.0005 133.399 48.0005 133.831 47.9981C134.198 47.9981 134.574 47.9934 134.941 47.9852C135.747 47.9752 136.552 47.9043 137.347 47.7731C138.146 47.6355 138.92 47.3804 139.644 47.0161C140.364 46.6515 141.021 46.1739 141.59 45.6017C142.163 45.0344 142.643 44.3806 143.012 43.6645C143.375 42.945 143.626 42.1744 143.757 41.3794C143.891 40.5853 143.966 39.7823 143.98 38.9771C143.985 38.6044 143.985 38.2434 143.985 37.8708C143.994 37.4349 143.994 37.0013 143.994 36.5583V11.444C143.994 11.0045 143.994 10.5686 143.985 10.1338C143.985 9.76585 143.985 9.39671 143.98 9.02874C143.966 8.22353 143.891 7.4205 143.757 6.62635C143.626 5.83176 143.375 5.06163 143.012 4.34237C142.269 2.89887 141.091 1.72387 139.644 0.982625C138.92 0.619323 138.146 0.365732 137.347 0.230228C136.552 0.0979673 135.747 0.0270535 134.941 0.0181162C134.574 0.0122602 134.198 0.00522827 133.831 0.00288827C133.399 0.000488281 132.959 0.000488281 132.527 0.000488281Z"
        fill="#A6A6A6"
      />
      <path
        d="M10.2859 46.7983C9.91999 46.7983 9.56296 46.7936 9.19996 46.7855C8.44797 46.7758 7.69774 46.7108 6.95543 46.5911C6.26326 46.4728 5.59273 46.2526 4.96596 45.938C4.34494 45.6259 3.77852 45.2167 3.28839 44.7261C2.79118 44.2412 2.37722 43.6789 2.06293 43.0613C1.74518 42.4398 1.52527 41.7735 1.41088 41.0858C1.28734 40.3468 1.2205 39.5996 1.21094 38.8506C1.20333 38.5992 1.19336 37.7621 1.19336 37.7621V10.2241C1.19336 10.2241 1.20397 9.39983 1.211 9.15768C1.22016 8.40985 1.28661 7.66381 1.40977 6.92599C1.52438 6.23639 1.74445 5.56822 2.06238 4.94461C2.37551 4.32748 2.78717 3.76471 3.28139 3.27812C3.77506 2.78691 4.34329 2.37562 4.96537 2.05924C5.5907 1.74558 6.25996 1.527 6.95073 1.41081C7.69549 1.2899 8.44832 1.22452 9.20291 1.21524L10.2864 1.20068H133.694L134.791 1.21582C135.539 1.22464 136.285 1.28944 137.023 1.40965C137.72 1.52729 138.397 1.7474 139.029 2.06273C140.275 2.70032 141.289 3.70904 141.929 4.94752C142.242 5.56682 142.459 6.22954 142.572 6.91319C142.696 7.65706 142.766 8.40897 142.78 9.16292C142.784 9.50052 142.784 9.86316 142.784 10.2241C142.793 10.6711 142.793 11.0966 142.793 11.5256V36.4745C142.793 36.9076 142.793 37.3302 142.784 37.7563C142.784 38.1439 142.784 38.4991 142.779 38.8646C142.765 39.6051 142.697 40.3435 142.574 41.0741C142.462 41.7668 142.243 42.4382 141.926 43.0649C141.609 43.6758 141.197 44.2332 140.706 44.7168C140.215 45.2101 139.648 45.6216 139.026 45.9357C138.395 46.2528 137.72 46.4737 137.023 46.5911C136.28 46.7115 135.53 46.7765 134.778 46.7855C134.426 46.7936 134.058 46.7983 133.7 46.7983L132.399 46.8007L10.2859 46.7983Z"
        fill="black"
      />
      <path
        d="M29.7191 24.3613C29.7453 22.3255 30.8125 20.4451 32.5468 19.3788C31.4478 17.8091 29.6729 16.8495 27.7576 16.7896C25.7426 16.5781 23.7891 17.9954 22.7623 17.9954C21.7156 17.9954 20.1347 16.8106 18.4322 16.8456C16.1923 16.918 14.1547 18.1607 13.0649 20.1191C10.7442 24.1372 12.4753 30.0424 14.6983 33.2904C15.8106 34.8808 17.1104 36.6573 18.8113 36.5943C20.4757 36.5253 21.0974 35.5329 23.1065 35.5329C25.0969 35.5329 25.6801 36.5943 27.4155 36.5543C29.2015 36.5253 30.3268 34.9568 31.4 33.3513C32.1991 32.2181 32.8141 30.9656 33.222 29.6403C31.1008 28.7431 29.7215 26.6645 29.7191 24.3613Z"
        fill="white"
      />
      <path
        d="M26.4407 14.6536C27.4145 13.4845 27.8942 11.9819 27.778 10.4648C26.2903 10.6211 24.916 11.3322 23.9291 12.4564C22.9545 13.5655 22.4608 15.0166 22.5567 16.49C24.0644 16.5056 25.4959 15.8287 26.4407 14.6536Z"
        fill="white"
      />
      <path
        d="M50.7583 32.5682H45.0784L43.7144 36.5959H41.3086L46.6885 21.6943H49.188L54.5679 36.5959H52.1211L50.7583 32.5682ZM45.6666 30.7096H50.1689L47.9494 24.1729H47.8873L45.6666 30.7096Z"
        fill="white"
      />
      <path
        d="M66.1868 31.1642C66.1868 34.5404 64.3798 36.7095 61.653 36.7095C60.2435 36.7833 58.9158 36.045 58.2347 34.8087H58.1831V40.19H55.9531V25.7314H58.1117V27.5384H58.1527C58.864 26.3099 60.1931 25.572 61.612 25.6177C64.3692 25.6177 66.1868 27.7974 66.1868 31.1642ZM63.8947 31.1642C63.8947 28.9646 62.758 27.5185 61.0237 27.5185C59.3198 27.5185 58.1738 28.9951 58.1738 31.1642C58.1738 33.3533 59.3198 34.8193 61.0237 34.8193C62.758 34.8193 63.8947 33.3838 63.8947 31.1642Z"
        fill="white"
      />
      <path
        d="M78.1438 31.1642C78.1438 34.5404 76.3369 36.7095 73.61 36.7095C72.2005 36.7833 70.8728 36.045 70.1918 34.8087H70.1402V40.19H67.9102V25.7314H70.0687V27.5384H70.1097C70.821 26.3099 72.1501 25.572 73.5689 25.6177C76.3263 25.6177 78.1438 27.7974 78.1438 31.1642ZM75.8517 31.1642C75.8517 28.9646 74.715 27.5185 72.9807 27.5185C71.2769 27.5185 70.1308 28.9951 70.1308 31.1642C70.1308 33.3533 71.2769 34.8193 72.9807 34.8193C74.715 34.8193 75.8517 33.3837 75.8517 31.1642Z"
        fill="white"
      />
      <path
        d="M86.0464 32.4439C86.2117 33.9216 87.6472 34.8919 89.6088 34.8919C91.4884 34.8919 92.8407 33.9216 92.8407 32.5892C92.8407 31.4325 92.0251 30.74 90.094 30.2653L88.1628 29.8001C85.4265 29.1392 84.1563 27.8595 84.1563 25.7829C84.1563 23.2118 86.3968 21.4458 89.5784 21.4458C92.727 21.4458 94.8856 23.2118 94.9582 25.7829H92.7071C92.5724 24.2958 91.3431 23.3982 89.5467 23.3982C87.7503 23.3982 86.521 24.3064 86.521 25.6282C86.521 26.6817 87.3061 27.3017 89.2268 27.7762L90.8685 28.1794C93.9258 28.9024 95.1961 30.1306 95.1961 32.3102C95.1961 35.0981 92.9755 36.8442 89.4436 36.8442C86.139 36.8442 83.9078 35.1391 83.7637 32.4438L86.0464 32.4439Z"
        fill="white"
      />
      <path
        d="M100.01 23.1606V25.7317H102.076V27.4978H100.01V33.4872C100.01 34.4177 100.423 34.8513 101.331 34.8513C101.577 34.847 101.822 34.8298 102.065 34.7997V36.5551C101.657 36.6314 101.242 36.666 100.826 36.6583C98.6269 36.6583 97.7691 35.8321 97.7691 33.7251V27.4978H96.1895V25.7317H97.7691V23.1606H100.01Z"
        fill="white"
      />
      <path
        d="M103.271 31.1643C103.271 27.7459 105.285 25.5979 108.424 25.5979C111.574 25.5979 113.578 27.7459 113.578 31.1643C113.578 34.592 111.584 36.7307 108.424 36.7307C105.265 36.7307 103.271 34.592 103.271 31.1643ZM111.306 31.1643C111.306 28.8194 110.231 27.4354 108.424 27.4354C106.617 27.4354 105.544 28.8299 105.544 31.1643C105.544 33.5186 106.617 34.892 108.424 34.892C110.231 34.892 111.306 33.5186 111.306 31.1643Z"
        fill="white"
      />
      <path
        d="M115.416 25.7313H117.543V27.5805H117.595C117.891 26.3901 118.982 25.5708 120.208 25.6176C120.465 25.6167 120.721 25.6446 120.972 25.7008V27.7868C120.647 27.6876 120.309 27.6421 119.97 27.652C119.314 27.6254 118.68 27.8867 118.233 28.3673C117.786 28.8478 117.572 29.4997 117.646 30.1516V36.5958H115.416V25.7313Z"
        fill="white"
      />
      <path
        d="M131.253 33.4052C130.953 35.3774 129.033 36.731 126.575 36.731C123.415 36.731 121.453 34.6134 121.453 31.2161C121.453 27.8083 123.425 25.5981 126.481 25.5981C129.487 25.5981 131.377 27.663 131.377 30.9571V31.7212H123.704V31.856C123.633 32.6648 123.912 33.4654 124.471 34.0542C125.03 34.643 125.815 34.9632 126.627 34.9333C127.709 35.0347 128.729 34.4133 129.136 33.4052L131.253 33.4052ZM123.715 30.1626H129.146C129.187 29.4358 128.922 28.7251 128.416 28.2016C127.91 27.6782 127.209 27.3895 126.481 27.4052C125.748 27.4008 125.043 27.6896 124.524 28.2074C124.004 28.7252 123.713 29.4291 123.715 30.1626Z"
        fill="white"
      />
      <path
        d="M45.389 10.4776C46.3357 10.4097 47.2629 10.7699 47.9156 11.4591C48.5682 12.1483 48.8774 13.0938 48.758 14.0354C48.758 16.3229 47.5217 17.6378 45.389 17.6378H42.8027V10.4776H45.389ZM43.9148 16.6252H45.2648C45.9413 16.6657 46.6001 16.3991 47.0581 15.8995C47.5162 15.4 47.7248 14.7206 47.626 14.05C47.7176 13.3822 47.506 12.7085 47.0491 12.213C46.5922 11.7175 45.9377 11.4521 45.2648 11.4895H43.9148V16.6252Z"
        fill="white"
      />
      <path
        d="M50.014 14.934C49.9214 13.9655 50.3858 13.0282 51.2125 12.5151C52.0392 12.0021 53.0852 12.0021 53.9119 12.5151C54.7386 13.0282 55.203 13.9655 55.1104 14.934C55.2048 15.9036 54.7408 16.8428 53.9134 17.3569C53.0859 17.871 52.0385 17.871 51.211 17.3569C50.3836 16.8428 49.9196 15.9036 50.014 14.934ZM54.0135 14.934C54.0135 13.7627 53.4874 13.0778 52.564 13.0778C51.637 13.0778 51.1156 13.7627 51.1156 14.934C51.1156 16.1147 51.6371 16.7944 52.564 16.7944C53.4874 16.7944 54.0135 16.11 54.0135 14.934Z"
        fill="white"
      />
      <path
        d="M61.8853 17.6379H60.7791L59.6624 13.6582H59.578L58.4659 17.6379H57.3703L55.8809 12.2344H56.9625L57.9304 16.3576H58.0101L59.121 12.2344H60.144L61.2549 16.3576H61.3393L62.3025 12.2344H63.3689L61.8853 17.6379Z"
        fill="white"
      />
      <path
        d="M64.6211 12.2342H65.6476V13.0926H65.7273C66.0044 12.4606 66.652 12.0739 67.3398 12.1299C67.8723 12.0898 68.3942 12.2941 68.758 12.6851C69.1219 13.0761 69.2882 13.6113 69.21 14.1396V17.6376H68.1436V14.4074C68.1436 13.5391 67.7663 13.1072 66.9777 13.1072C66.6164 13.0904 66.2659 13.2322 66.0179 13.4954C65.7699 13.7586 65.6492 14.1169 65.6875 14.4765V17.6377H64.6211V12.2342Z"
        fill="white"
      />
      <path
        d="M70.9082 10.125H71.9746V17.6379H70.9082V10.125Z"
        fill="white"
      />
      <path
        d="M73.4574 14.9336C73.3648 13.965 73.8293 13.0277 74.656 12.5147C75.4828 12.0016 76.5289 12.0016 77.3556 12.5147C78.1824 13.0277 78.6469 13.965 78.5543 14.9336C78.6486 15.9033 78.1845 16.8424 77.357 17.3565C76.5296 17.8706 75.4821 17.8706 74.6546 17.3565C73.8271 16.8424 73.3631 15.9033 73.4574 14.9336ZM77.4569 14.9336C77.4569 13.7624 76.9307 13.0774 76.0073 13.0774C75.0804 13.0774 74.5589 13.7624 74.5589 14.9337C74.5589 16.1143 75.0804 16.794 76.0073 16.794C76.9307 16.794 77.4569 16.1096 77.4569 14.9336Z"
        fill="white"
      />
      <path
        d="M79.6777 16.1101C79.6777 15.1374 80.4019 14.5767 81.6874 14.497L83.1511 14.4126V13.9462C83.1511 13.3755 82.7737 13.0532 82.0448 13.0532C81.4496 13.0532 81.0371 13.2718 80.9187 13.6538H79.8863C79.9953 12.7257 80.8683 12.1304 82.0941 12.1304C83.4487 12.1304 84.2127 12.8048 84.2127 13.9462V17.6382H83.1862V16.8788H83.1018C82.7532 17.4334 82.1332 17.7575 81.4789 17.7272C81.0202 17.7749 80.5627 17.6264 80.2195 17.3182C79.8764 17.0101 79.6795 16.5712 79.6777 16.1101ZM83.1511 15.6483V15.1966L81.8316 15.2809C81.0874 15.3307 80.75 15.5839 80.75 16.0602C80.75 16.5466 81.1718 16.8296 81.7519 16.8296C82.0953 16.8643 82.4382 16.7582 82.7019 16.5356C82.9656 16.3129 83.1277 15.9927 83.1511 15.6483Z"
        fill="white"
      />
      <path
        d="M85.6152 14.9338C85.6152 13.2264 86.4929 12.1447 87.8581 12.1447C88.5475 12.113 89.1931 12.4824 89.5151 13.0927H89.5948V10.125H90.6612V17.6379H89.6393V16.7842H89.555C89.2086 17.3895 88.555 17.7526 87.8581 17.7269C86.4836 17.727 85.6152 16.6453 85.6152 14.9338ZM86.7168 14.9338C86.7168 16.0799 87.257 16.7696 88.1605 16.7696C89.0593 16.7696 89.6147 16.07 89.6147 14.9385C89.6147 13.8123 89.0534 13.1028 88.1605 13.1028C87.2628 13.1028 86.7168 13.7971 86.7168 14.9338Z"
        fill="white"
      />
      <path
        d="M95.0707 14.934C94.978 13.9655 95.4424 13.0282 96.2691 12.5151C97.0958 12.0021 98.1419 12.0021 98.9686 12.5151C99.7952 13.0282 100.26 13.9655 100.167 14.934C100.261 15.9036 99.7974 16.8428 98.97 17.3569C98.1426 17.871 97.0951 17.871 96.2677 17.3569C95.4403 16.8428 94.9763 15.9036 95.0707 14.934ZM99.0702 14.934C99.0702 13.7627 98.544 13.0778 97.6206 13.0778C96.6937 13.0778 96.1722 13.7627 96.1722 14.934C96.1722 16.1147 96.6937 16.7944 97.6206 16.7944C98.544 16.7944 99.0702 16.11 99.0702 14.934Z"
        fill="white"
      />
      <path
        d="M101.6 12.2342H102.626V13.0926H102.706C102.983 12.4606 103.63 12.0739 104.318 12.1299C104.851 12.0898 105.373 12.2941 105.737 12.6851C106.1 13.0761 106.267 13.6113 106.189 14.1396V17.6376H105.122V14.4074C105.122 13.5391 104.745 13.1072 103.956 13.1072C103.595 13.0904 103.244 13.2322 102.996 13.4954C102.748 13.7586 102.628 14.1169 102.666 14.4765V17.6377H101.6V12.2342Z"
        fill="white"
      />
      <path
        d="M112.212 10.8892V12.2591H113.383V13.1573H112.212V15.9358C112.212 16.5019 112.446 16.7497 112.976 16.7497C113.112 16.7493 113.248 16.7411 113.383 16.7251V17.6134C113.192 17.6476 112.998 17.6659 112.803 17.6679C111.617 17.6679 111.145 17.2507 111.145 16.2089V13.1573H110.287V12.259H111.145V10.8892H112.212Z"
        fill="white"
      />
      <path
        d="M114.84 10.125H115.897V13.1027H115.981C116.272 12.4652 116.93 12.0781 117.629 12.1348C118.158 12.106 118.673 12.3148 119.033 12.7043C119.393 13.0939 119.56 13.6236 119.49 14.1492V17.6379H118.422V14.4123C118.422 13.5492 118.02 13.1121 117.267 13.1121C116.896 13.0817 116.53 13.2165 116.268 13.4807C116.006 13.7448 115.873 14.1112 115.906 14.482V17.6379H114.84L114.84 10.125Z"
        fill="white"
      />
      <path
        d="M125.708 16.1788C125.409 17.1981 124.423 17.8566 123.367 17.7421C122.646 17.7611 121.954 17.4624 121.473 16.9253C120.992 16.3883 120.772 15.667 120.871 14.953C120.775 14.237 120.994 13.5146 121.472 12.973C121.95 12.4314 122.64 12.1238 123.362 12.13C124.865 12.13 125.773 13.1572 125.773 14.854V15.2261H121.957V15.2858C121.923 15.6868 122.06 16.0834 122.334 16.3781C122.608 16.6728 122.994 16.8383 123.396 16.8338C123.918 16.8965 124.426 16.6377 124.682 16.1788L125.708 16.1788ZM121.957 14.4374H124.686C124.713 14.0707 124.584 13.7095 124.331 13.443C124.078 13.1764 123.724 13.0292 123.356 13.0376C122.984 13.0329 122.625 13.1789 122.361 13.4425C122.098 13.706 121.952 14.0648 121.957 14.4374Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2669_62827">
        <rect width="144" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function PlayStore({ fill = '#000', className }) {
return (
  <svg
    width="162"
    height="48"
    viewBox="0 0 162 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2669_62863)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156 48.0005H6C2.7 48.0005 0 45.3005 0 42.0005V6.00049C0 2.70049 2.7 0.000488281 6 0.000488281H156C159.3 0.000488281 162 2.70049 162 6.00049V42.0005C162 45.3005 159.3 48.0005 156 48.0005Z"
        fill="#A6A6A6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M155.999 0.960938C158.778 0.960938 161.039 3.22174 161.039 6.00094V42.0009C161.039 44.7801 158.778 47.0409 155.999 47.0409H5.99898C3.21978 47.0409 0.958984 44.7801 0.958984 42.0009V6.00094C0.958984 3.22174 3.21978 0.960938 5.99898 0.960938H155.999Z"
        fill="black"
      />
      <path
        d="M36.1014 27.0245L17.2168 37.9111C15.5494 38.8723 13.4197 38.2979 12.4599 36.628C12.1556 36.0986 11.9955 35.4985 11.9955 34.8876L11.9955 13.1146C11.9955 11.1879 13.5551 9.62598 15.479 9.62598C16.0889 9.62598 16.6881 9.78636 17.2168 10.0911L36.1014 20.9774C37.7688 21.9386 38.3424 24.0715 37.3826 25.7413C37.0761 26.2747 36.634 26.7174 36.1014 27.0245Z"
        fill="url(#paint0_linear_2669_62863)"
      />
      <mask
        id="mask0_2669_62863"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="11"
        y="9"
        width="27"
        height="30"
      >
        <path
          d="M36.0995 27.0245L17.2148 37.9111C15.5475 38.8723 13.4177 38.2979 12.458 36.628C12.1537 36.0986 11.9935 35.4985 11.9935 34.8876L11.9935 13.1146C11.9935 11.1879 13.5531 9.62598 15.477 9.62598C16.0869 9.62598 16.6862 9.78636 17.2148 10.0911L36.0994 20.9774C37.7668 21.9386 38.3405 24.0715 37.3807 25.7413C37.0741 26.2747 36.6321 26.7174 36.0995 27.0245Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2669_62863)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9952 8.38965L27.1955 23.7498L11.7988 39.717L11.9952 8.38965Z"
          fill="url(#paint1_linear_2669_62863)"
        />
      </g>
      <mask
        id="mask1_2669_62863"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="11"
        y="9"
        width="27"
        height="30"
      >
        <path
          d="M36.0995 27.0245L17.2148 37.9111C15.5475 38.8723 13.4177 38.2979 12.458 36.628C12.1537 36.0986 11.9935 35.4985 11.9935 34.8876L11.9935 13.1146C11.9935 11.1879 13.5531 9.62598 15.477 9.62598C16.0869 9.62598 16.6862 9.78636 17.2148 10.0911L36.0994 20.9774C37.7668 21.9386 38.3405 24.0715 37.3807 25.7413C37.0741 26.2747 36.6321 26.7174 36.0995 27.0245Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_2669_62863)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.86914 5.22754L27.1934 23.7542L32.6415 18.4701L8.86914 5.22754Z"
          fill="url(#paint2_linear_2669_62863)"
        />
      </g>
      <mask
        id="mask2_2669_62863"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="11"
        y="9"
        width="27"
        height="30"
      >
        <path
          d="M36.0995 27.0245L17.2148 37.9111C15.5475 38.8723 13.4177 38.2979 12.458 36.628C12.1537 36.0986 11.9935 35.4985 11.9935 34.8876L11.9935 13.1146C11.9935 11.1879 13.5531 9.62598 15.477 9.62598C16.0869 9.62598 16.6862 9.78636 17.2148 10.0911L36.0994 20.9774C37.7668 21.9386 38.3405 24.0715 37.3807 25.7413C37.0741 26.2747 36.6321 26.7174 36.0995 27.0245Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_2669_62863)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.1988 23.7507L35.5391 32.2979L10.623 40.845L27.1988 23.7507Z"
          fill="url(#paint3_linear_2669_62863)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.6906 15.6005V8.40055H91.8174L95.3166 14.0021H95.3562L95.3166 12.6137V8.40055H96.2418V15.6005H95.2758L91.6146 9.72775H91.575L91.6146 11.1161V15.6005H90.6906ZM83.7354 14.0669C84.2682 14.6069 84.9198 14.8757 85.6914 14.8757C86.463 14.8757 87.1146 14.6069 87.6474 14.0669C88.1802 13.5281 88.4478 12.8381 88.4478 12.0005C88.4478 11.1629 88.1802 10.4741 87.6474 9.93415C87.1146 9.39415 86.463 9.12535 85.6914 9.12535C84.9198 9.12535 84.2682 9.39415 83.7354 9.93415C83.2038 10.4741 82.9362 11.1629 82.9362 12.0005C82.9362 12.8381 83.2038 13.5281 83.7354 14.0669ZM88.3314 14.6705C87.6234 15.3977 86.7438 15.7613 85.6914 15.7613C84.639 15.7613 83.7594 15.3977 83.0526 14.6705C82.3446 13.9433 81.9918 13.0529 81.9918 12.0005C81.9918 10.9481 82.3446 10.0577 83.0526 9.33055C83.7594 8.60335 84.639 8.23975 85.6914 8.23975C86.7378 8.23975 87.615 8.60455 88.3266 9.33535C89.037 10.0661 89.3922 10.9541 89.3922 12.0005C89.3922 13.0529 89.0382 13.9433 88.3314 14.6705ZM76.9542 15.6005H76.029V9.28495H74.0178V8.40055H78.9654V9.28495H76.9542V15.6005ZM71.9262 15.6005H72.8514V8.40055H71.9262V15.6005ZM66.3354 15.6005H65.409V9.28495H63.3978V8.40055H68.3454V9.28495H66.3354V15.6005ZM62.4342 9.28495H59.1546V11.5685H62.1114V12.4325H59.1546V14.7161H62.4342V15.6005H58.2306V8.40055H62.4342V9.28495ZM56.9022 12.2921C56.9022 13.2977 56.6046 14.0993 56.0082 14.6957C55.3314 15.4061 54.4482 15.7613 53.3634 15.7613C52.3242 15.7613 51.441 15.4013 50.7138 14.6801C49.9866 13.9601 49.623 13.0661 49.623 12.0005C49.623 10.9337 49.9866 10.0409 50.7138 9.32095C51.441 8.59975 52.3242 8.23975 53.3634 8.23975C53.8794 8.23975 54.3726 8.34055 54.8418 8.54095C55.3098 8.74255 55.6866 9.01015 55.9674 9.34615L55.335 9.97855C54.8574 9.40975 54.201 9.12535 53.3634 9.12535C52.605 9.12535 51.9498 9.39055 51.3966 9.92455C50.8434 10.4573 50.5674 11.1497 50.5674 12.0005C50.5674 12.8525 50.8434 13.5437 51.3966 14.0765C51.9498 14.6105 52.605 14.8757 53.3634 14.8757C54.1674 14.8757 54.8382 14.6081 55.3746 14.0729C55.7226 13.7237 55.9242 13.2377 55.9782 12.6137H53.3634V11.7497H56.8518C56.8866 11.9369 56.9022 12.1181 56.9022 12.2921Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M128.325 36.0006H130.564V20.9994H128.325V36.0006ZM148.493 26.403L145.926 32.907H145.85L143.186 26.403H140.774L144.768 35.493L142.491 40.5498H144.826L150.983 26.403H148.493ZM135.795 34.2966C135.06 34.2966 134.038 33.9294 134.038 33.0222C134.038 31.8642 135.311 31.4214 136.412 31.4214C137.396 31.4214 137.859 31.6338 138.458 31.923C138.284 33.3126 137.087 34.2966 135.795 34.2966ZM136.065 26.0754C134.444 26.0754 132.764 26.7894 132.069 28.371L134.057 29.2014C134.482 28.371 135.273 28.101 136.103 28.101C137.261 28.101 138.438 28.7958 138.458 30.0306V30.1854C138.052 29.9538 137.183 29.607 136.122 29.607C133.98 29.607 131.799 30.7842 131.799 32.9838C131.799 34.9914 133.556 36.2838 135.524 36.2838C137.03 36.2838 137.859 35.6094 138.381 34.8174H138.458V35.9754H140.619V30.2238C140.619 27.561 138.632 26.0754 136.065 26.0754ZM122.226 28.2294H119.042V23.0862H122.226C123.9 23.0862 124.851 24.4734 124.851 25.6578C124.851 26.8206 123.9 28.2294 122.226 28.2294ZM122.169 20.9994H116.804V36.0006H119.042V30.3174H122.169C124.65 30.3174 127.09 28.5198 127.09 25.6578C127.09 22.7958 124.65 20.9994 122.169 20.9994ZM92.9116 34.299C91.3648 34.299 90.07 33.0042 90.07 31.2258C90.07 29.4282 91.3648 28.113 92.9116 28.113C94.4392 28.113 95.6368 29.4282 95.6368 31.2258C95.6368 33.0042 94.4392 34.299 92.9116 34.299ZM95.482 27.243H95.4052C94.9024 26.6442 93.9364 26.1018 92.7184 26.1018C90.166 26.1018 87.8272 28.3446 87.8272 31.2258C87.8272 34.0866 90.166 36.3102 92.7184 36.3102C93.9364 36.3102 94.9024 35.769 95.4052 35.1498H95.482V35.8842C95.482 37.8378 94.4392 38.8806 92.7567 38.8806C91.3839 38.8806 90.5332 37.8954 90.1852 37.0638L88.2328 37.8762C88.7932 39.2298 90.2823 40.8918 92.7567 40.8918C95.3859 40.8918 97.6096 39.345 97.6096 35.5758V26.4114H95.482V27.243ZM99.1552 36.0006H101.398V20.9982H99.1552V36.0006ZM104.704 31.0518C104.646 29.079 106.232 28.0746 107.372 28.0746C108.262 28.0746 109.016 28.5186 109.266 29.157L104.704 31.0518ZM111.664 29.3502C111.238 28.209 109.943 26.1018 107.295 26.1018C104.666 26.1018 102.482 28.1706 102.482 31.2066C102.482 34.0674 104.646 36.3102 107.546 36.3102C109.886 36.3102 111.238 34.8798 111.8 34.0482L110.06 32.8878C109.479 33.7386 108.687 34.299 107.546 34.299C106.406 34.299 105.593 33.777 105.071 32.7534L111.896 29.9298L111.664 29.3502ZM57.2944 27.669V29.8338H62.4748C62.32 31.0518 61.9144 31.941 61.2964 32.559C60.5416 33.3138 59.362 34.1442 57.2944 34.1442C54.1036 34.1442 51.61 31.5738 51.61 28.383C51.61 25.1934 54.1036 22.623 57.2944 22.623C59.0152 22.623 60.2716 23.2986 61.1992 24.1686L62.7268 22.6422C61.4308 21.405 59.7112 20.457 57.2944 20.457C52.9252 20.457 49.252 24.015 49.252 28.383C49.252 32.7534 52.9252 36.3102 57.2944 36.3102C59.6524 36.3102 61.4308 35.5362 62.8228 34.0866C64.2532 32.6562 64.6984 30.6462 64.6984 29.0214C64.6984 28.5186 64.66 28.0554 64.582 27.669H57.2944ZM70.588 34.299C69.0424 34.299 67.708 33.0234 67.708 31.2066C67.708 29.3694 69.0424 28.113 70.588 28.113C72.1348 28.113 73.4692 29.3694 73.4692 31.2066C73.4692 33.0234 72.1348 34.299 70.588 34.299ZM70.588 26.1018C67.7656 26.1018 65.4652 28.2486 65.4652 31.2066C65.4652 34.1442 67.7656 36.3102 70.588 36.3102C73.4104 36.3102 75.712 34.1442 75.712 31.2066C75.712 28.2486 73.4104 26.1018 70.588 26.1018ZM81.7648 34.299C80.218 34.299 78.8836 33.0234 78.8836 31.2066C78.8836 29.3694 80.218 28.113 81.7648 28.113C83.3116 28.113 84.6448 29.3694 84.6448 31.2066C84.6448 33.0234 83.3116 34.299 81.7648 34.299ZM81.7648 26.1018C78.9424 26.1018 76.642 28.2486 76.642 31.2066C76.642 34.1442 78.9424 36.3102 81.7648 36.3102C84.5872 36.3102 86.8876 34.1442 86.8876 31.2066C86.8876 28.2486 84.5872 26.1018 81.7648 26.1018Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2669_62863"
        x1="37.8477"
        y1="1447.17"
        x2="-968.128"
        y2="1447.17"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDA09" />
        <stop offset="1" stopColor="#FFBC00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2669_62863"
        x1="595.128"
        y1="1840.27"
        x2="1051.46"
        y2="1581.24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#01E2FF" />
        <stop offset="1" stopColor="#01C4FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2669_62863"
        x1="490.997"
        y1="596.128"
        x2="1778.28"
        y2="1596.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#28D781" />
        <stop offset="1" stopColor="#02F076" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2669_62863"
        x1="1866.58"
        y1="617.175"
        x2="585.502"
        y2="1621.08"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F2414E" />
        <stop offset="1" stopColor="#E02554" />
      </linearGradient>
      <clipPath id="clip0_2669_62863">
        <rect width="162" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function AndroidIcon({ fill = '#000', className }) {
return (
  <svg
    width="29"
    height="32"
    viewBox="0 0 29 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3719_17334)">
      <path
        d="M14.799 18.087C19.5399 18.087 23.3831 14.5987 23.3831 10.2957C23.3831 5.99268 19.5399 2.50439 14.799 2.50439C10.0581 2.50439 6.21484 5.99268 6.21484 10.2957C6.21484 14.5987 10.0581 18.087 14.799 18.087Z"
        fill="#6C819C"
        stroke="white"
        strokeWidth="1.33565"
      />
      <path
        d="M21.3078 8.3479H8.29013C7.14398 8.3479 6.21484 9.2615 6.21484 10.3885V23.1885C6.21484 24.3155 7.14398 25.2291 8.29013 25.2291H21.3078C22.454 25.2291 23.3831 24.3155 23.3831 23.1885V10.3885C23.3831 9.2615 22.454 8.3479 21.3078 8.3479Z"
        fill="#6C819C"
        stroke="white"
        strokeWidth="1.33565"
      />
      <path
        d="M8.93565 1.25752C8.77148 0.966295 8.87849 0.599349 9.17466 0.437921C9.47084 0.276493 9.84403 0.381713 10.0082 0.672937L13.3467 6.595C13.5109 6.88622 13.4038 7.25317 13.1077 7.4146C12.8115 7.57603 12.4383 7.47081 12.2741 7.17958L8.93565 1.25752Z"
        fill="#6C819C"
        stroke="white"
        strokeWidth="0.667826"
      />
      <path
        d="M23.7612 12.5217C23.7612 11.2923 24.7748 10.2957 26.0251 10.2957C27.2755 10.2957 28.2891 11.2923 28.2891 12.5217V20.4058C28.2891 21.6352 27.2755 22.6319 26.0251 22.6319C24.7748 22.6319 23.7612 21.6352 23.7612 20.4058V12.5217Z"
        fill="#6C819C"
        stroke="white"
        strokeWidth="0.667826"
      />
      <path
        d="M15.7416 21.5189C15.7416 20.2894 16.7552 19.2928 18.0056 19.2928C19.2559 19.2928 20.2695 20.2894 20.2695 21.5189V29.4029C20.2695 30.6324 19.2559 31.629 18.0056 31.629C16.7552 31.629 15.7416 30.6324 15.7416 29.4029V21.5189Z"
        fill="#6C819C"
        stroke="white"
        strokeWidth="0.667826"
      />
      <path
        d="M20.662 1.25752C20.8262 0.966295 20.7192 0.599349 20.423 0.437921C20.1268 0.276493 19.7536 0.381713 19.5895 0.672937L16.251 6.595C16.0868 6.88622 16.1938 7.25317 16.49 7.4146C16.7862 7.57603 17.1594 7.47081 17.3235 7.17958L20.662 1.25752Z"
        fill="#6C819C"
        stroke="white"
        strokeWidth="0.667826"
      />
      <path
        d="M5.83648 12.5217C5.83648 11.2923 4.82288 10.2957 3.57254 10.2957C2.3222 10.2957 1.30859 11.2923 1.30859 12.5217V20.4058C1.30859 21.6352 2.3222 22.6319 3.57254 22.6319C4.82288 22.6319 5.83648 21.6352 5.83648 20.4058V12.5217Z"
        fill="#6C819C"
        stroke="white"
        strokeWidth="0.667826"
      />
      <path
        d="M13.856 21.5189C13.856 20.2894 12.8424 19.2928 11.5921 19.2928C10.3417 19.2928 9.32812 20.2894 9.32812 21.5189V29.4029C9.32812 30.6324 10.3417 31.629 11.5921 31.629C12.8424 31.629 13.856 30.6324 13.856 29.4029V21.5189Z"
        fill="#6C819C"
        stroke="white"
        strokeWidth="0.667826"
      />
      <path
        d="M14.799 18.087C19.5399 18.087 23.3831 14.5987 23.3831 10.2957C23.3831 5.99268 19.5399 2.50439 14.799 2.50439C10.0581 2.50439 6.21484 5.99268 6.21484 10.2957C6.21484 14.5987 10.0581 18.087 14.799 18.087Z"
        fill="#6C819C"
      />
      <path
        d="M21.3078 8.3479H8.29013C7.14398 8.3479 6.21484 9.2615 6.21484 10.3885V23.1885C6.21484 24.3155 7.14398 25.2291 8.29013 25.2291H21.3078C22.454 25.2291 23.3831 24.3155 23.3831 23.1885V10.3885C23.3831 9.2615 22.454 8.3479 21.3078 8.3479Z"
        fill="#6C819C"
      />
      <path d="M5.83984 10.6203H23.7627H5.83984Z" fill="white" />
      <path
        d="M5.83984 10.6203H23.7627"
        stroke="white"
        strokeWidth="0.667826"
      />
      <path
        d="M10.8383 6.86379C11.0467 6.86379 11.2156 6.69769 11.2156 6.49278C11.2156 6.28787 11.0467 6.12177 10.8383 6.12177C10.6299 6.12177 10.4609 6.28787 10.4609 6.49278C10.4609 6.69769 10.6299 6.86379 10.8383 6.86379Z"
        fill="white"
        stroke="white"
        strokeWidth="0.667826"
      />
      <path
        d="M18.764 6.86379C18.9724 6.86379 19.1414 6.69769 19.1414 6.49278C19.1414 6.28787 18.9724 6.12177 18.764 6.12177C18.5557 6.12177 18.3867 6.28787 18.3867 6.49278C18.3867 6.69769 18.5557 6.86379 18.764 6.86379Z"
        fill="white"
        stroke="white"
        strokeWidth="0.667826"
      />
    </g>
    <defs>
      <clipPath id="clip0_3719_17334">
        <rect
          width="27.7333"
          height="32"
          fill="white"
          transform="translate(0.933594)"
        />
      </clipPath>
    </defs>
  </svg>
)
}
export function iosIcon({ fill = '#000', className }) {
return (
  <svg
    width="26"
    height="32"
    viewBox="0 0 26 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3719_17333)">
      <path
        d="M25.1175 10.9088C24.9351 11.0528 21.7146 12.8992 21.7146 17.0048C21.7146 21.7536 25.8125 23.4336 25.9352 23.4752C25.9163 23.5776 25.2842 25.776 23.7746 28.016C22.4285 29.9872 21.0227 31.9552 18.8842 31.9552C16.7456 31.9552 16.1952 30.6912 13.7264 30.6912C11.3205 30.6912 10.4651 31.9968 8.50894 31.9968C6.55277 31.9968 5.18785 30.1728 3.61852 27.9328C1.80073 25.3024 0.332031 21.216 0.332031 17.3376C0.332031 11.1168 4.30727 7.8176 8.2196 7.8176C10.2984 7.8176 12.0313 9.2064 13.3365 9.2064C14.5787 9.2064 16.516 7.7344 18.881 7.7344C19.7773 7.7344 22.9978 7.8176 25.1175 10.9088ZM17.7583 5.1008C18.7364 3.92 19.4282 2.2816 19.4282 0.6432C19.4282 0.416 19.4094 0.1856 19.3685 0C17.7771 0.0608 15.8839 1.0784 14.7423 2.4256C13.8459 3.4624 13.0094 5.1008 13.0094 6.7616C13.0094 7.0112 13.0503 7.2608 13.0691 7.3408C13.1698 7.36 13.3333 7.3824 13.4968 7.3824C14.9247 7.3824 16.7204 6.4096 17.7583 5.1008Z"
        fill="#6C819C"
      />
    </g>
    <defs>
      <clipPath id="clip0_3719_17333">
        <rect
          width="25.6"
          height="32"
          fill="white"
          transform="translate(0.332031)"
        />
      </clipPath>
    </defs>
  </svg>
)
}
export function ClockIcon({ fill = '#000', className }) {
return (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_112_2101)">
      <path
        d="M13.3086 11.7903L13.1058 7.05727C13.0785 6.49347 12.6257 6.02733 12.0501 6.00133C11.4395 5.97393 10.9219 6.4466 10.8941 7.05727L10.6667 12.3373L10.666 12.3483C10.6523 12.694 10.7884 13.043 11.0674 13.2903L14.3587 15.9225C14.7793 16.2923 15.4241 16.2956 15.8447 15.9063C16.2936 15.4915 16.3209 14.791 15.9056 14.3418L13.3086 11.7903ZM12.0052 2C6.4798 2 2 6.47653 2 12C2 17.5235 6.4798 22 12.0052 22C17.5273 22 22 17.5235 22 12C22 6.47653 17.5273 2 12.0052 2ZM12.0039 19.4661C7.95177 19.4661 4.53317 16.0508 4.53317 12C4.53317 7.9492 7.95177 4.53387 12.0039 4.53387C16.0534 4.53387 19.4668 7.9492 19.4668 12C19.4668 16.0508 16.0534 19.4661 12.0039 19.4661Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_112_2101">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function KeyIcon({ fill = '#000', className }) {
return (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_372_30296)">
      <path
        d="M49.2539 39.2096L38.0394 27.9985C38.7548 26.1043 39.1651 24.0591 39.1651 21.9144C39.1619 12.391 31.4423 4.6691 21.9155 4.66675C12.3871 4.66753 4.66288 12.391 4.66602 21.916C4.66445 31.4427 12.3871 39.1644 21.9124 39.1652C24.0596 39.1652 26.1039 38.7629 27.9998 38.0469L32.2602 42.3012H39.1642V49.1888L39.2289 49.2531C42.0038 52.0271 46.4756 52.0264 49.2536 49.2538C52.0255 46.4828 52.0258 41.9845 49.2539 39.2096ZM21.6951 21.6924C19.3491 24.0384 16.0643 24.5529 14.3535 22.844C12.6446 21.1296 13.1591 17.848 15.5023 15.5019C17.8468 13.1596 21.1316 12.6459 22.8437 14.3549C24.5525 16.0661 24.038 19.3495 21.6951 21.6924Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_372_30296">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function BankIcon({ fill = '#000', className }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_469_13694)">
      <path
        d="M13.7784 12.2857H2.22287C1.73372 12.2857 1.33398 12.6716 1.33398 13.1429C1.33398 13.6141 1.73372 14 2.22287 14H13.7784C14.2676 14 14.6673 13.6141 14.6673 13.1429C14.6673 12.6716 14.2676 12.2857 13.7784 12.2857ZM14.4694 5.07208C14.3587 5.00094 11.719 3.31551 8.15647 2.02732C8.05578 1.99089 7.94554 1.99089 7.84485 2.02732C4.28234 3.31551 1.64258 5.00094 1.5319 5.07208C1.40821 5.15158 1.33398 5.28551 1.33398 5.42865V6.28578C1.33398 6.52265 1.53321 6.71435 1.77843 6.71435H2.66732V11.4286H5.33398V6.71435H6.66732V11.4286H9.33398V6.71435H10.6673V11.4286H13.334V6.71435H14.2229C14.4681 6.71435 14.6673 6.52265 14.6673 6.28578V5.42865C14.6673 5.28551 14.5931 5.15158 14.4694 5.07208Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_469_13694">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function DocumentIcon({ fill = '#000', className }) {
return (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_469_14496)">
      <path
        d="M7.15385 13.3341H16.8462V12.0007H7.15385V13.3341ZM7.15385 10.6672H16.8462V9.33382H7.15385V10.6672ZM20.1873 2.69018C20.0555 2.66218 16.909 2 12.0054 2C7.10178 2 3.94583 2.66151 3.81332 2.69018C3.33805 2.79172 3 3.19801 3 3.66611V20.3345C3 20.8033 3.33805 21.2096 3.81332 21.3111C5.73811 21.7178 9.74855 22.1351 14.0877 21.9583C16.0261 21.9583 21 17.1917 21 15.3342V3.66611C21 3.19801 20.6619 2.79239 20.1873 2.69018ZM18.9231 14.3335C18.9231 14.8856 18.4579 15.3335 17.8846 15.3335V15.3342H15.1404C15.1404 15.3355 15.1404 15.3355 15.1404 15.3361C15.1337 15.3361 15.1276 15.3342 15.1208 15.3342C14.5461 15.3342 14.0824 15.7822 14.0824 16.3343C14.0824 16.3408 14.0844 16.3473 14.0844 16.3531C14.0837 16.3531 14.083 16.3531 14.0824 16.3531V18.9745C14.0824 18.979 14.0837 18.9829 14.0837 18.9881C14.0837 18.992 14.0824 18.9959 14.0824 19.0005V19.0011C14.0743 19.5405 13.6245 20.0598 13.0398 20.0598C13.0398 20.0611 13.0398 20.0611 13.0398 20.0624C10.1448 20.124 7.78952 19.929 5.07692 19.5012V4.49883C6.27832 4.31005 8.74197 3.92853 12.0054 3.92853C15.256 3.92853 17.7203 4.31002 18.9231 4.4995L18.9258 14.3341C18.9244 14.3341 18.9238 14.3335 18.9231 14.3335ZM7.15385 8.0004H16.8462V6.66698H7.15385V8.0004Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_469_14496">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function DocumentSmallIcon({ fill = '#000', className }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_469_14496)">
      <path
        d="M7.15385 13.3341H16.8462V12.0007H7.15385V13.3341ZM7.15385 10.6672H16.8462V9.33382H7.15385V10.6672ZM20.1873 2.69018C20.0555 2.66218 16.909 2 12.0054 2C7.10178 2 3.94583 2.66151 3.81332 2.69018C3.33805 2.79172 3 3.19801 3 3.66611V20.3345C3 20.8033 3.33805 21.2096 3.81332 21.3111C5.73811 21.7178 9.74855 22.1351 14.0877 21.9583C16.0261 21.9583 21 17.1917 21 15.3342V3.66611C21 3.19801 20.6619 2.79239 20.1873 2.69018ZM18.9231 14.3335C18.9231 14.8856 18.4579 15.3335 17.8846 15.3335V15.3342H15.1404C15.1404 15.3355 15.1404 15.3355 15.1404 15.3361C15.1337 15.3361 15.1276 15.3342 15.1208 15.3342C14.5461 15.3342 14.0824 15.7822 14.0824 16.3343C14.0824 16.3408 14.0844 16.3473 14.0844 16.3531C14.0837 16.3531 14.083 16.3531 14.0824 16.3531V18.9745C14.0824 18.979 14.0837 18.9829 14.0837 18.9881C14.0837 18.992 14.0824 18.9959 14.0824 19.0005V19.0011C14.0743 19.5405 13.6245 20.0598 13.0398 20.0598C13.0398 20.0611 13.0398 20.0611 13.0398 20.0624C10.1448 20.124 7.78952 19.929 5.07692 19.5012V4.49883C6.27832 4.31005 8.74197 3.92853 12.0054 3.92853C15.256 3.92853 17.7203 4.31002 18.9231 4.4995L18.9258 14.3341C18.9244 14.3341 18.9238 14.3335 18.9231 14.3335ZM7.15385 8.0004H16.8462V6.66698H7.15385V8.0004Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_469_14496">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function ArrowHeadRightIcon({ fill = '#000', className }) {
return (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_469_14505)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.93372 5.72C8.8763 5.60525 7.49739 2.88308 4.98591 1.11387C4.79492 0.979619 4.54529 0.962911 4.33757 1.06995C4.13032 1.17737 4 1.39141 4 1.62495V10.375C4 10.6085 4.13032 10.8225 4.33757 10.93C4.54579 11.0372 4.79437 11.0204 4.98591 10.8856C7.49739 9.11683 8.8763 6.39466 8.93374 6.27991C9.02209 6.1037 9.02209 5.8962 8.93372 5.72Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_469_14505">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function ArrowHeadDownIcon({ fill = '#000', className, onClick }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <g clipPath="url(#clip0_976_5703)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.37269 11.245C8.52569 11.1685 12.1552 9.32994 14.5142 5.9813C14.6932 5.72664 14.7155 5.3938 14.5727 5.11685C14.4295 4.8405 14.1441 4.66675 13.8327 4.66675L2.16607 4.66675C1.85469 4.66675 1.5693 4.8405 1.42607 5.11685C1.28307 5.39447 1.30546 5.72591 1.48519 5.9813C3.84358 9.32994 7.47313 11.1685 7.62613 11.2451C7.86108 11.3629 8.13774 11.3629 8.37269 11.245Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_976_5703">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function ArrowHeadUpIcon({ fill = '#000', className, onClick }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <g clipPath="url(#clip0_1399_5508)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.37269 4.75495C8.52569 4.83152 12.1552 6.67006 14.5142 10.0187C14.6932 10.2734 14.7155 10.6062 14.5727 10.8832C14.4295 11.1595 14.1441 11.3333 13.8327 11.3333L2.16607 11.3333C1.85469 11.3333 1.5693 11.1595 1.42607 10.8832C1.28307 10.6055 1.30546 10.2741 1.48519 10.0187C3.84358 6.67006 7.47313 4.83152 7.62613 4.75493C7.86108 4.63713 8.13774 4.63713 8.37269 4.75495Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1399_5508">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function ArrowHeadLeftIcon({ fill = '#000', className }) {
return (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_1153_13982)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.08772 7.6267C4.16428 7.4737 6.00282 3.84414 9.35147 1.4852C9.60613 1.3062 9.93896 1.28392 10.2159 1.42664C10.4923 1.56987 10.666 1.85526 10.666 2.16664V13.8333C10.666 14.1447 10.4923 14.4301 10.2159 14.5733C9.93829 14.7163 9.60685 14.6939 9.35147 14.5142C6.00282 12.1558 4.16428 8.52626 4.08769 8.37326C3.9699 8.13831 3.9699 7.86165 4.08772 7.6267Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1153_13982">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function UpdraftLogoIcon({ fill = '#000', className }) {
return (
  <svg
    className={className}
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1189_2133)">
      <path
        d="M26.7534 16.9429L26.7149 16.7196C25.9516 12.4209 24.5953 8.24889 22.6848 4.32302L22.5847 4.12026C21.5573 2.00969 19.2538 0.837168 16.9425 1.24825L16.7192 1.28675C12.4182 2.04866 8.2438 3.40392 4.31559 5.31372L4.12307 5.40868C2.00945 6.43581 0.836096 8.74233 1.25064 11.0552L1.33021 11.4966C2.10577 15.7973 3.47507 19.9693 5.39885 23.8932C6.43169 25.9999 8.73687 27.1659 11.0462 26.7498L11.2823 26.7088C12.0114 26.5804 12.7352 26.4264 13.4566 26.2647C13.4052 26.2647 13.3513 26.2493 13.3 26.2365H13.2743C13.0379 26.1817 12.8529 25.9978 12.7968 25.7617C12.6891 25.2939 12.6891 24.8076 12.7968 24.3398V24.2936C12.8511 24.0546 13.0378 23.8679 13.2769 23.8137H13.2974C13.7653 23.7059 14.2516 23.7059 14.7195 23.8137H14.7426C14.9806 23.8672 15.1665 24.0531 15.2201 24.291V24.3141C15.3278 24.782 15.3278 25.2682 15.2201 25.736V25.7591C15.2114 25.7871 15.2011 25.8145 15.1893 25.8413C18.1127 25.0622 20.9545 24.0041 23.6757 22.6818L23.8784 22.5817C25.9899 21.5562 27.1638 19.2538 26.7534 16.9429ZM19.0525 18.4983L15.9003 21.6423C15.3967 22.1464 14.7133 22.4296 14.0008 22.4296C13.2882 22.4296 12.6048 22.1464 12.1012 21.6423L8.95667 18.4983C6.0945 15.634 5.94048 10.9448 8.77955 8.0574C10.156 6.65723 12.0372 5.86858 14.0008 5.86858C15.9643 5.86858 17.8456 6.65723 19.222 8.0574C22.061 10.9448 21.9096 15.634 19.0448 18.4983H19.0525Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1189_2133">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function UpdraftLogoIconMobile({ fill = '#000', className }) {
return (
  <svg
    className={className}
    width="72px"
    height="72px"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1189_2133)">
      <path
        d="M26.7534 16.9429L26.7149 16.7196C25.9516 12.4209 24.5953 8.24889 22.6848 4.32302L22.5847 4.12026C21.5573 2.00969 19.2538 0.837168 16.9425 1.24825L16.7192 1.28675C12.4182 2.04866 8.2438 3.40392 4.31559 5.31372L4.12307 5.40868C2.00945 6.43581 0.836096 8.74233 1.25064 11.0552L1.33021 11.4966C2.10577 15.7973 3.47507 19.9693 5.39885 23.8932C6.43169 25.9999 8.73687 27.1659 11.0462 26.7498L11.2823 26.7088C12.0114 26.5804 12.7352 26.4264 13.4566 26.2647C13.4052 26.2647 13.3513 26.2493 13.3 26.2365H13.2743C13.0379 26.1817 12.8529 25.9978 12.7968 25.7617C12.6891 25.2939 12.6891 24.8076 12.7968 24.3398V24.2936C12.8511 24.0546 13.0378 23.8679 13.2769 23.8137H13.2974C13.7653 23.7059 14.2516 23.7059 14.7195 23.8137H14.7426C14.9806 23.8672 15.1665 24.0531 15.2201 24.291V24.3141C15.3278 24.782 15.3278 25.2682 15.2201 25.736V25.7591C15.2114 25.7871 15.2011 25.8145 15.1893 25.8413C18.1127 25.0622 20.9545 24.0041 23.6757 22.6818L23.8784 22.5817C25.9899 21.5562 27.1638 19.2538 26.7534 16.9429ZM19.0525 18.4983L15.9003 21.6423C15.3967 22.1464 14.7133 22.4296 14.0008 22.4296C13.2882 22.4296 12.6048 22.1464 12.1012 21.6423L8.95667 18.4983C6.0945 15.634 5.94048 10.9448 8.77955 8.0574C10.156 6.65723 12.0372 5.86858 14.0008 5.86858C15.9643 5.86858 17.8456 6.65723 19.222 8.0574C22.061 10.9448 21.9096 15.634 19.0448 18.4983H19.0525Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1189_2133">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
}
export function UserGroupIcon({ fill = '#000' }) {
return (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1510_33541)">
      <path d="M7.99992 5.23044C8.67693 5.23044 9.54062 5.53959 9.92561 6.40669C10.3353 7.32967 10.2307 8.35542 9.28372 9.51949C8.70581 10.2298 9.43687 10.6919 10.26 11.1844L10.451 11.2987C10.6745 11.433 10.8979 11.5711 11.0974 11.7184C11.84 12.2664 11.8114 12.5345 11.9906 13.3665C12.0386 13.5842 11.8985 13.7996 11.6825 13.8356C10.3425 14.0547 5.65774 14.0548 4.31735 13.8356C4.10083 13.7996 3.96141 13.5838 4.00915 13.3665C4.18843 12.5345 4.15981 12.2664 4.90239 11.7184C5.04448 11.6135 5.19888 11.5132 5.35692 11.4157L5.54775 11.2997C6.44124 10.7634 7.33956 10.2859 6.71609 9.51949C5.76913 8.35542 5.66451 7.32967 6.07423 6.40669C6.45919 5.53959 7.32286 5.23044 7.99992 5.23044ZM5.33337 2C6.61369 2 7.48636 2.94361 7.48344 4.21553C5.12483 4.58758 3.85449 7.36091 5.73613 9.94651C5.29171 10.2333 5.00897 10.3653 4.44453 10.762C2.304 10.7334 1.68728 10.6113 1.65083 10.6052C1.43431 10.5691 1.29489 10.3534 1.34262 10.136C1.5219 9.30406 1.49328 9.03594 2.23587 8.48792C2.37795 8.38303 2.53236 8.28279 2.6904 8.18521L2.88123 8.06927C3.77472 7.53299 4.67304 7.05542 4.04957 6.28905C3.10259 5.12499 2.99797 4.09923 3.40768 3.17625C3.79262 2.30915 4.65632 2 5.33337 2ZM10.6665 2C11.3435 2 12.2072 2.30915 12.5921 3.17625C13.0019 4.09923 12.8972 5.12499 11.9503 6.28905C11.1723 7.24531 12.7664 7.75152 13.764 8.48792C14.5066 9.03594 14.4779 9.30406 14.6572 10.136C14.7051 10.3538 14.5651 10.5692 14.349 10.6052C14.3126 10.6113 13.6958 10.7334 11.5553 10.762C11.0212 10.3872 10.7082 10.2318 10.2637 9.9472C12.1387 7.39081 10.8922 4.5903 8.51633 4.21553C8.51338 2.9419 9.38799 2 10.6665 2Z" fill="#5D1CD3"/>
    </g>
    <defs>
      <clipPath id="clip0_1510_33541">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)
}